import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter, AfterViewInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { DocumentStatus } from 'src/app/shared/models/iCourrier/status-management/document-status';
import { Source } from 'src/app/shared/models/iCourrier/source';
import { Nature } from 'src/app/shared/models/iCourrier/nature';
import { ServicesOnlyParent, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { MailInsert } from 'src/app/shared/models/iCourrier/post/mail-insert';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { Subject, Observable, Subscription, forkJoin } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, FormControl, Validators, AbstractControl, FormGroup } from '@angular/forms';
import { ErrorService } from 'src/app/shared/services/error.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { GlobalModalComponent } from 'src/app/components/modals/global-modal/global-modal.component';
import { HttpErrorModalComponent } from 'src/app/components/modals/http-error-modal/http-error-modal.component';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/shared/services/data.service';
import { Mail } from 'src/app/shared/models/mails/mail';
import * as async from 'async';
import * as _ from 'underscore';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalStatus } from 'src/app/shared/models/iCourrier/status-management/global-status';
import { ContactNewComponent } from '../../CONTACT/contact-new/contact-new.component';
import { ParamsService } from 'src/app/shared/services/params.service';
import { Dropdown } from 'primeng/dropdown';
import { DialogService } from 'primeng/dynamicdialog';
import { ContactEditionComponent } from '../../CONTACT/contact-edition/contact-edition.component';
import { TranslateService } from '@devinforius/i-essentials';
import { TreeSelect } from 'primeng/treeselect';
import { WorkflowsService } from 'src/app/shared/services/workflows.service';
import { Bacs, BacsDTO } from 'src/app/shared/models/workflows/bacs';
import { IDelibeService } from 'src/app/shared/services/i-delibe.service';
import { Point } from 'src/app/shared/models/iDelibe/point';
import { ServicesService } from 'src/app/shared/services/services.service';
import {
  BinderClassificationDetailsBinderDTOV2,
  BinderClassificationDtoV2,
  DropdownClassificationCode,
  DropdownService,
  FolderManagementDTO,
  MailCreatedDTO,
  MailCreationRightDto,
  MailLinkDto,
  MailWithFilesCreatedDTO,
} from 'src/app/shared/interfaces';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { MyOwnService, MyOwnServiceDto } from 'src/app/shared/interfaces/services/my-own-service-dto.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MeService } from 'src/app/shared/services/me.service';
import { AutoComplete } from 'primeng/autocomplete';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { ICourrierScanService } from 'src/app/shared/services/iCourrier-scan.service';
import { MailCreateScanLotFullParams } from 'src/app/shared/models/iCourrier/scans/mail-create-scan-lot-full';
import { ScanSentToEditionComponent } from 'src/app/shared/models/iCourrier/scans/scan-sent-to-edition-component';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { IScanAPIService } from 'src/app/shared/services/iscan.service';
import { NaturesSources } from 'src/app/shared/models/iCourrier/params-admin/natures-sources';
import { ObjectsTemplatesService } from 'src/app/shared/services/objects-templates.service';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { WorkflowInstance, WorkflowInstanceDTO } from 'src/app/shared/models/workflows/workflow-instance';
import * as lodash from 'lodash';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';
import {
  MailMultipleStatutes,
  MailMultipleStatutesDTO,
  MultipleStatutesDTO,
} from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { GlobalSpecificStatutesService } from 'src/app/shared/services/global-specific-statutes.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { FilesService } from 'src/app/shared/services/files.service';
import { MailsReplyService } from 'src/app/shared/services/mails-reply.service';
import { MailsRightsService } from 'src/app/shared/services/mails-rights.service';
import { MailsLinksService } from 'src/app/shared/services/mails-links.service';
import { Cols } from 'src/app/shared/models/cols';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';
import { ActivatedRoute, Router } from '@angular/router';
import { MailFullInfosDTO } from 'src/app/shared/interfaces/mails/mail-dto.interface';
import { GlobalStatusDTO } from 'src/app/shared/interfaces/global/global-status.interface';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { GroupsMembersDTO } from 'src/app/shared/interfaces/groups/groups-members.interface';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { MailsLockUnlockService } from 'src/app/shared/services/mails-lock-unlock.service';
import { MailLockEntryDTO } from 'src/app/shared/interfaces/mails/mails-lock-dto.interface';
import { MailDetails } from 'src/app/shared/models/mails/mail-details-dto.';
import { MatrixService } from 'src/app/shared/services/matrix.service';
import { RightManagement } from 'src/app/shared/models/iCourrier/right/right-management';
import { MatrixDTO } from 'src/app/shared/interfaces/global/global-matrix.interface';
import { RechercheContacts } from 'src/app/shared/interfaces/contacts/dtos/recherche-contacts-dto.interface';
import { AllErrorResponse } from 'src/app/shared/models/error-response-from-backend';
import { ITabs } from '@devinforius/i-navigation';
import {
  manageServicesSetAsTreeSelect,
  manageServicesToBeMerged,
  returnOnlyParentServices,
} from 'src/app/shared/utils/manage-services-for-tree-select.utils';

export class MyTreeNode implements TreeNode {
  public children: MyTreeNode[] = [];
  public expanded: boolean;
  public key: string;
  constructor(
    public label: string,
    public isLeaf: boolean
  ) {
    this.expanded = !isLeaf;
    this.key = label;
  }
}

@Component({
  selector: 'app-courrier-edition-form',
  templateUrl: './courrier-edition-form.component.html',
  styleUrls: ['./courrier-edition-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmationService],
})
export class CourrierEditionFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('treeSelect') treeSelect: TreeSelect;
  @ViewChild('autocomplete') autocomplete: AutoComplete;

  @ViewChild('Dropdown') stateDropdown: Dropdown;
  @Output() public formChange = new EventEmitter<FormGroup>();
  @Output() public formState = new EventEmitter<{ form: UntypedFormGroup; isFormSubmit: boolean }>();
  @Output() public canSubmit = new EventEmitter<boolean>(); // info from courrierEditor for the submit button
  @Output() public newMail = new EventEmitter<MailCreatedDTO | MailWithFilesCreatedDTO>();
  @Output() public isFormValid = new EventEmitter<boolean>();
  @Input() public globalSubmitE: Observable<void>; // global submit click button
  private submitSubscription: Subscription; // listen on global submit click button
  @Input() public isAnswerMode: boolean;
  @Input() public isNew: boolean; // if true form is in modal
  @Input() public mailId: number;
  @Input() public expediteurId: number; // expediteur become destinataire on submit
  @Input() public mailType: string; // 'E' | 'S' | 'I';
  @Input() public courrierFile: MailInsert;
  @Input() public serviceProprietaireId: number;
  @Input() public scan?: ScanSentToEditionComponent;
  @Input() public mail: Mail;
  @Input() public duplicatedMailIdFromiScan?: number; //* Will receive the id of the courrier to get and patch its metadata into the form (coming from courrier-create.component). more infos in courrier-create.component :)
  @Input() public mailMode: string; // used to check if it's not in editor mode when file open
  @Input() public isDuplicateMode: boolean;
  @Input() public createNewCourrierForIDelibe: boolean;
  public natureList: Nature[];
  public sourceList: Source[];
  public statutList: DocumentStatus[];
  // Label Value Format for prime Ng dropdown
  public natureListLV: { label: string; value: number }[] = [];
  public sourceListLV: { label: string; value: number; typeMail: boolean }[] = [];
  public statutListLV: { label: string; value: number; ordre: number }[] = [];
  public typesLV: { label: string; value: string }[] = [];

  public courrier: MailDetails | MailInsert;
  public userServices: MyOwnService[] = [];
  public selectedUserService: MyOwnServiceDto = null; // the service configuration for the serviceProprietaire selected
  public selectedService: DropdownService; // the serviceProprietaire selected
  public userInfos: UserInfo; // Access of the connected user
  public configuration: ConfigDto;
  public locale4Calendar: AssetsCalendarFr; // locale for calendar
  public isCourrier: boolean; // if false other tags are not available
  public services: DropdownService[];
  public dateEcheance: Date;

  public isLoaded: boolean;
  public tempMail: Mail;
  public isFormSubmit = false;
  public linkMailAnswer: MailLinkDto & {
    objet?: string;
  }; // to hide delete btn if current mail  is an answer of this one
  public selectedOptionParent: string;
  public tempContact: { label: string; value: number; id: number; adresse: string; typeContactID: number; nameTypeContact: string }[] = [];
  public links: (MailLinkDto & {
    objet?: string;
  })[] = [];

  public users: Array<Contact> = [];

  public form: UntypedFormGroup;
  public userData: RechercheContacts;
  private ngUnsubscribe = new Subject(); // For errors messages
  public typeEntrantSortant: string; //'E' | 'S' | 'I' = 'E';
  public displayModalTree = false;
  public contactTypes: { label: string; value: number }[] = [];
  public contacts: Partial<Contact>[] = [];
  public showRefRecommanded = false;
  public selectedOption: {
    label: string;
    value: number;
    parentId: number;
  } = null;

  public destAnswerId: number;
  public dest4Answer: Contact;
  public destLibre: string;
  public statutGlobalLV: { label: string; value: number; color: string }[] = [];
  public attachements: File[] = [];
  public statutGlobal: GlobalStatus[] = [];
  public searchServices = '';
  public userIDService: number[] = [];
  public createFromFile = false;
  public readOnly4Info = false;
  public hasDateDocument = false;
  public expediteurIdArray: number[] = [];

  private formSubscription: Subscription;

  public canLeaveEditor: boolean;

  public tags: { label: string; value: number; color: string; notUsed: boolean }[] = [];
  public tagsCourrier: MailMultipleStatutes[] = [];
  public showStatusDropdown = false;
  public refreshContact = true;
  public servicesCreation: Array<
    MailCreationRightDto & {
      selectable: boolean;
      addMailSortantChild: boolean;
      addMailEntrantChild: boolean;
      addMailInterneChild: boolean;
    }
  > = [];
  public servicesModification: Array<MyOwnService> = [];
  public serviceParent: ServicesPTreeSelect[] = [];
  public showCreate = false;
  public showCreateNewClassement = false;
  public formNewClassement = new UntypedFormGroup({
    description: new FormControl(null, Validators.required),
    actif: new FormControl(true),
    code: new FormControl(null, Validators.required),
  });
  public showCreateNewClasseur = false;
  public formNewFarde = new UntypedFormGroup({
    archive: new FormControl(),
    accesRestreint: new FormControl(),
    description: new FormControl(null, Validators.required),
    localisation: new FormControl(),
    lieAficheContact: new FormControl(),
    remarques: new FormControl(),
  });
  public showCreateNewChemise = false;
  public formNewChemise = new UntypedFormGroup({
    accesRestreint: new FormControl(),
    description: new FormControl(null, Validators.required),
    archive: new FormControl(),
    localisation: new FormControl(),
    lieAficheContact: new FormControl(),
    remarques: new FormControl(),
  });

  public formNatureSource = new UntypedFormGroup({
    ordreTri: new FormControl(null),
    description: new FormControl(null, Validators.required),
    accuseReceptionAutomatique: new FormControl(false),
    afficherReferenceRecommande: new FormControl(false),
    envoiRecommande: new FormControl(false),
    typeCategorieFichier: new FormControl(false),
    typeMail: new FormControl(false),
    typeNature: new FormControl(false),
    typeSource: new FormControl(false),
    serviceIds: new FormControl(false),
    type: new FormControl('typeSource', Validators.required),
  });
  public servicesFusionned: {
    label: string;
    value: number;
    parentId: number;
    id: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public defaultRef = 'Non';
  public rightUser: RightManagement;
  public codesclassementsLV: DropdownClassificationCode[] = [];
  public chemisesLV: { label: string; value: number; partage: boolean; service: string }[] = [];
  public classeursLV: { label: string; value: number; partage: boolean }[] = [];
  public serviceID: number;
  public dataMatrice = {
    svcPropId: null,
    type: null,
    natureId: null,
    sourceId: null,
  };
  public checkMatrice: MatrixDTO;
  public allDatasForChosenService: BinderClassificationDtoV2[] = [];
  public allClasseurs: BinderClassificationDetailsBinderDTOV2[] = [];
  public contactInfoComplementary: {
    type: string;
    societeParente: string;
    impression_Adresse: string;
    impression_CodePostal: string;
    impression_Localite: string;
    impression_Pays: string;
    gsm: string;
    telephone: string;
    mail: string;
  }[] = [];
  public display = false;
  public columnsContactInfoComplementary: Cols[] = [
    {
      field: 'type',
      header: 'contactType',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'impression_Adresse',
      header: 'address',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'impression_CodePostal',
      header: 'ZIPCode',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'impression_Localite',
      header: 'town',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'impression_Pays',
      header: 'country',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return this.translater.translate('belgium');
        }
      },
    },
    {
      field: 'gsm',
      header: 'mobilePhone',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'telephone',
      header: 'phone',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'mail',
      header: 'email',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
  ];
  public rightSelectedServices: MailCreationRightDto & {
    selectable: boolean;
    addMailSortantChild: boolean;
    addMailEntrantChild: boolean;
    addMailInterneChild: boolean;
  } = null;
  public hideForm = false;
  public showCreateObject = false;
  public formObject: UntypedFormGroup = new UntypedFormGroup({
    objet: new FormControl(null),
    serviceId: new FormControl(null),
  });
  public objectsmodeles: { label: string; value: string; serviceId: number }[] = [];
  public openBibli = false;
  public objectModel: string;

  public classeurCheckArchived = false;
  public chemiseCheckArchived = false;

  public allContactsEvenInactivesOnes;
  public expediteurUserNeededToBeAdded; //Will contain the expediteur so if in case it's inactive, we'll simply add it inside the dropdowns => Will be possible to see the basic expediteur even if it's inactive! (users => Sortants or Internes)
  public expediteurContactNeededToBeAdded; //(contacts => Entrant)

  public actionTabs: ITabs[] = [{ header: 'existingSenderV', id: 'existing', active: true }];
  public expediteurTabsActive = 'existing';
  isSavingNewExpediteur: Subject<void> = new Subject<void>();

  public canSaveContact = false;
  public courrierIsSaved = new EventEmitter<MailLockEntryDTO>();
  public currentUserLockInfo: MailLockEntryDTO;

  public translationPlaceholderPTree = '';
  public dataToPrepareForForm: {
    controls?: {
      customFieldId: number;
      id: number;
      name: string;
      description: string;
      label: string;
      textValue: string;
      dateValue: string;
      integerValue: number;
      decimalValue: number;
      numberValue: number;
      listValueItemId: number[];
      defaultFormValue: string;
      type: string;
      natureId: number;
      validators: Validators;
      utilisable: boolean;
    }[];
  };

  public numerisations_center: { label: string; value: number; item: GlobalCentreNumerisationDTO }[] = [];
  public servicesOnlyParent: ServicesOnlyParent[] = [];
  public showAllServices = true;
  public displayWarningChildServiceDetected = false;
  public currentBac;

  public isDropdownToggled = false;
  public loadingClasseurChemise = false;

  public formDatasToSendBackToCreateBinder = null;
  public formDatasToSendBackToCreatePlasticLiner = null;
  public MailUniqueId = null;

  public isFromIAdmin = true;

  public destinatairesMailAnswered = [];

  public groupsMemberUserConnected: GroupsMembersDTO[] = [];

  public pointIdFromIDelibe: number = null;

  public displayCreateEditPlasticLinerComponent = false;
  public displayCreateEditBinderComponent = false;
  public selectedRowDataForModal = null;
  public headerForModal: string;
  public lastCreatedPlasticLiner = null;
  public lastCreatedBinder: FolderManagementDTO = null;
  public displaySenderModal = false;
  public displayModalClassificationSearch = false;
  public serviceDataForClassificationSearchModal: { serviceProprietaireId: number };

  public filteredExpediteurs: Contact[] = [];
  public subscriptionToAutocompleteSender: Subscription = null;

  public natureWithComplementaryDatas;
  public loadingComplementaryDatas = false;

  public recipientSourceBoolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private errorService: ErrorService,
    private translationService: TranslationService,
    private toastr: ToastrService,
    private dataService: DataService,
    public confirmationService: ConfirmationService,
    private spinner: NgxSpinnerService,
    private router: Router,
    public renderer: Renderer2,
    public params: ParamsService,
    private dialogService: DialogService,
    private translater: TranslateService,
    public workflows: WorkflowsService,
    private servicesService: ServicesService,
    private classificationsService: ClassificationsService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private mailsService: MailsService,
    private iDelibeApi: IDelibeService,
    private meService: MeService,
    private configService: ConfigService,
    private sourcesService: SourcesService,
    private naturesService: NaturesService,
    private iCourrierScanService: ICourrierScanService,
    private iScanApiService: IScanAPIService,
    private objectsTemplatesService: ObjectsTemplatesService,
    private multipleStatutesService: MultipleStatutesService,
    private contactsGlobalService: ContactsGlobalService,
    private documentsService: DocumentsService,
    private globalSpecificStatutesService: GlobalSpecificStatutesService,
    private recipientsService: RecipientsService,
    private filesService: FilesService,
    private mailsReplyService: MailsReplyService,
    private mailsRightsService: MailsRightsService,
    private mailsLinksService: MailsLinksService,
    private route: ActivatedRoute,
    private groupsService: GroupsService,
    private numerisationCentersService: NumerisationCentersService,
    private mailsLockUnlockService: MailsLockUnlockService,
    private matrixService: MatrixService
  ) {}

  ngOnInit(): void {
    //petite info : quand on vient de courrier create avec un mail déjà existant : que ce soit une modif de courrier, une réponse,...
    //ne vous fiez pas au formulaire! En fait, on a tellement de fonctionnements distincts qu'ils rentrent en conflits les uns avec les autres....
    //Donc, gardez toujours à l'esprit qu'on doit patcher dans le form, oui mais gardez vos valeurs dans une variable globale (ex : this.tempMail) puis repatcher par après.
    //un exemple bête avec this.tempMail, le onServiceSelect unpatch les données classeur et chemise et HOP au revoir dans le form. Dans certains cas c'est obligatoire, dans d'autres non...
    //pour plus d'infos, regardez le spaghetti dans le setTimeout dans la méthode getClasseur. J'ai du faire du setTimeout, pour repatcher les données en fonction de this.courrier et this.tempMail
    // à cause de leur fonctionnement qui ne demande pas d'unpatch les données... => on veut garder ces infos.
    // Donc vérifiez bien que les données que vous voulez utiliser existent encore quand vous les utilisez :)
    //Amicalement votre
    // AVA 🦊
    this.initForm();
    if (this.mailType) {
      this.typeEntrantSortant = this.mailType;
    }
    if (JSON.parse(sessionStorage.getItem('createFromFile'))) {
      this.createFromFile = true;
    }
    if (
      this.mailMode &&
      !this.scan &&
      (this.mailMode === 'mailModel' || this.mailMode === 'mailNoModel' || this.mailMode === 'emailnomodel' || this.mailMode === 'emailmodel')
    ) {
      this.readOnly4Info = true;
    }
    if (this.scan || this.mailMode === 'edit' || this.mailMode === 'duplicate' || this.isAnswerMode || this.mailMode === 'fileViewer') {
      this.readOnly4Info = false;
      // If we are in scan from encodage complet, we have to get this right to check if services children are shown or not
      if (this.scan) {
        this.isNew = true;
        this.getRightMail().then((res) => {
          this.showAllServices = !res.iScan.limitFirstLevelService;
        });
      }
    } else {
      this.readOnly4Info = true;
    }

    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    this.spinner.show();
    this.getTranslations();
    async.waterfall(
      [
        (cb) => {
          this.getUserInfo().then(() => {
            cb();
          });
        },
        (cb) => {
          this.getSourcelist().then(() => {
            cb();
          });
        },
        (cb) => {
          if (!this.userData) {
            this.getUserData(this.userInfos.contactId).then(() => {
              cb();
            });
          } else cb();
        },
        (cb) => {
          this.getGroupsMembersOfContactIds().then(() => {
            cb();
          });
        },
        (cb) => {
          this.getContactType().then(() => {
            cb();
          });
        },
        (cb) => {
          this.getAllCenterNums().then(() => {
            cb();
          });
        },
        (cb) => {
          if (this.isNew) {
            // Si on crée un nouveau courrier alors il faut checker les droits liés a la création
            this.getUserRightsMailsCreation().then(() => {
              cb();
            });
          } else {
            cb();
          }
        },
        (cb) => {
          this.meService.rightManagement().subscribe({
            next: (res) => {
              this.rightUser = res;
              cb();
            },
          });
        },
        (cb) => {
          this.getUserServices().then(() => {
            cb();
          });
        },
        (cb) => {
          this.getNaturesList().then(() => cb());
        },
        (cb) => {
          this.initializeErrors();
          this.getStatutList();
          this.getConfiguration(); // get User configuration for mail editing
          this.getLocale4Calendar();
          this.listenToSubmitEvent();
          this.getGlobalTypes();

          // For the next method we need to send false to typeChange() if we have a this.courrierFile
          // It only happens in the OnInit() of the component and it'll send the info of doing this.changeContactsSource('iAdmin') or not
          // If we have a this.courrierFile here, it means we already called the method to get the contacts from iCourrier (or to have a free recipient) so we clearly don't need to call changeContactsSource with iAdmin.
          this.typeChange(this.typeEntrantSortant);
          cb(null);
        },
        (cb) => {
          if (this.isAnswerMode) {
            this.getDestinatairesMailAnswered().then(() => {
              this.getMail();
            });
          } else if (this.mailId) {
            this.getMail();
          }

          if (this.courrierFile) {
            this.getCourrierByFile();
          }

          if (this.mail) {
            this.mail.sender = { email: this.mail.expediteurEmail };
            this.mail.objet = this.mail.subject;
            this.mail.dateEntree = this.mail.date;
            this.mail.dateDocument = this.mail.date;
            this.mail.datePostale = null;
            this.mail.dateEcheance = null;
            this.mail.sourceId = this.sourceListLV.find((x) => x.typeMail === true)?.value;
            this.mailType = this.mail.typeEntrantSortant;
            this.courrier = new MailDetails(this.mail);
            this.courrierFile = new MailInsert(this.mail);
            this.mail.serviceProprietaire = null;
            this.getServiceList(this.mail);
            this.getCourrierByFile();
            this.getClassements('isFromUpdate'); //besoin du courrier avant de get
            this.isNew = false;
            this.readOnly4Info = false;
          }
          if (this.scan?.scanGuid) {
            this.isNew = true;
            this.getServiceList();
            //* Firstly we'll do an async inside the timeout (timeout needed to wait for this.getServiceList() )
            //* On the first callback let's see if there's a "this.duplicatedMailIdFromiScan"
            //* if yes => getting the mail by the duplicatedMailIdFromiScan sent and then patching its metadatas into the form
            //* We arrive here if we come from a scan and more precisely a scan that will be inside a new courrier which is duplicated from an existing one
            let duplicatedMailDatasFromiScan = null;
            async.waterfall([
              (callback) => {
                if (this.duplicatedMailIdFromiScan) {
                  this.mailsService.fetchMailDetails(this.duplicatedMailIdFromiScan).subscribe({
                    next: (res: MailFullInfosDTO) => {
                      this.courrier = new MailDetails(res);
                      duplicatedMailDatasFromiScan = res;

                      if (duplicatedMailDatasFromiScan) {
                        this.form.patchValue({
                          annexeNonScannee: duplicatedMailDatasFromiScan.annexeNonScannee ? duplicatedMailDatasFromiScan.annexeNonScannee : null,
                          annexeNonScanneeNombre: duplicatedMailDatasFromiScan.annexeNonScanneeNombre
                            ? duplicatedMailDatasFromiScan.annexeNonScanneeNombre
                            : null,
                          annexeDiffusee: duplicatedMailDatasFromiScan.annexeDiffusee ? duplicatedMailDatasFromiScan.annexeDiffusee : null,
                          typeEntrantSortant: duplicatedMailDatasFromiScan.typeEntrantSortant
                            ? duplicatedMailDatasFromiScan.typeEntrantSortant
                            : null,
                          confidentiel: duplicatedMailDatasFromiScan.confidentiel ? duplicatedMailDatasFromiScan.confidentiel : null,
                          refExpediteur: duplicatedMailDatasFromiScan.refExpediteur ? duplicatedMailDatasFromiScan.refExpediteur : null,
                          dateEntree: duplicatedMailDatasFromiScan.dateEntree ? moment(duplicatedMailDatasFromiScan.dateEntree).toDate() : null,
                          dateDocument: duplicatedMailDatasFromiScan.dateDocument ? moment(duplicatedMailDatasFromiScan.dateDocument).toDate() : null,
                          dateEcheance: duplicatedMailDatasFromiScan.dateEcheance ? moment(duplicatedMailDatasFromiScan.dateEcheance).toDate() : null,
                          datePostale: duplicatedMailDatasFromiScan.datePostale ? moment(duplicatedMailDatasFromiScan.datePostale).toDate() : null,
                          objet: duplicatedMailDatasFromiScan.objet ? duplicatedMailDatasFromiScan.objet : null,
                          expediteurLibre: duplicatedMailDatasFromiScan.expediteurLibre ? duplicatedMailDatasFromiScan.expediteurLibre : null,
                          classementId: duplicatedMailDatasFromiScan.classementId ? duplicatedMailDatasFromiScan.classementId : null,
                          natureId: duplicatedMailDatasFromiScan.natureId ? duplicatedMailDatasFromiScan.natureId : null,
                          sourceId: duplicatedMailDatasFromiScan.sourceId ? duplicatedMailDatasFromiScan.sourceId : null,
                          referenceRecommande: duplicatedMailDatasFromiScan.referenceRecommande
                            ? duplicatedMailDatasFromiScan.referenceRecommande
                            : null,
                          statutId: duplicatedMailDatasFromiScan.statutId ? duplicatedMailDatasFromiScan.statutId : null,
                          boiteArchive: duplicatedMailDatasFromiScan.boiteArchive ? duplicatedMailDatasFromiScan.boiteArchive : null,
                          remarques: duplicatedMailDatasFromiScan.remarques ? duplicatedMailDatasFromiScan.remarques : null,
                          CentreNumerisationId: duplicatedMailDatasFromiScan.centreNumerisationId
                            ? duplicatedMailDatasFromiScan.centreNumerisationId
                            : null,
                          isFromIAdmin: true,
                        });
                        this.typeEntrantSortant = duplicatedMailDatasFromiScan.typeEntrantSortant;
                        if (duplicatedMailDatasFromiScan.sourceId) {
                          this.showRef(duplicatedMailDatasFromiScan.sourceId);
                        }
                      }
                      //!! on ne PATCH PAS le classeur et la chemise, cela se fera dans les sous méthodes de getClassements() afin d'éviter de patcher des données alors qu'on en a peut-être pas le droit
                      this.getClassements('isFromUpdate'); //besoin du patch de value avant de get
                      this.checkForComplementaryData(duplicatedMailDatasFromiScan.natureId);
                      if (duplicatedMailDatasFromiScan.typeEntrantSortant === 'E') {
                        this.actionTabs.push({ header: 'newSender', id: 'new', active: false });
                        this.actionTabs.push({ header: 'freeSender', id: 'free', active: false });
                        this.actionTabs = _.uniq(this.actionTabs, 'id');

                        if (duplicatedMailDatasFromiScan.expediteurLibre && duplicatedMailDatasFromiScan.expediteurLibre !== '') {
                          this.setTabExpediteurToFree();
                        }
                      } else {
                        const tempIndex = this.actionTabs.map((x) => x.id).indexOf('free');
                        if (tempIndex > -1) {
                          this.actionTabs.splice(tempIndex, 1);
                        }
                        const tempIndex2 = this.actionTabs.map((x) => x.id).indexOf('new');
                        if (tempIndex2 > -1) {
                          this.actionTabs.splice(tempIndex2, 1);
                        }
                      }
                      //translation of actionTabs
                      this.actionTabs.map((tab) => {
                        tab.header = this.translater.translate(tab.header);
                      });
                      callback();
                    },
                  });
                } else {
                  //Si on est ici c'est que c'est pas un dupliqué mais juste un nouveau
                  this.getClassements();
                  callback();
                }
              },
              (callback) => {
                this.isLoaded = true;
                //* Next let's patch the services
                this.patchValueFromScan(this.scan, duplicatedMailDatasFromiScan).then(() => {
                  //on doit avoir ou un service dans le QRCode (this.scan?.file?.ServiceProprietaireId) OU un service dans le mail dupliqué (duplicatedMailDatasFromiScan?.serviceProprietaireId)
                  //En sachant que dans this.patchValueFromScan , si on avait un service dans le QRCode on l'a remis dans duplicatedMailDatasFromiScan histoire d'avoir directement le bon service
                  if (this.scan?.file?.ServiceProprietaireId || duplicatedMailDatasFromiScan?.serviceProprietaireId) {
                    const serviceProp = this.scan?.file?.ServiceProprietaireId
                      ? this.scan?.file?.ServiceProprietaireId
                      : duplicatedMailDatasFromiScan?.serviceProprietaireId;
                    this.serviceProprietaireId = serviceProp;

                    if (this.form.value.typeEntrantSortant === 'S' || this.form.value.typeEntrantSortant === 'I') {
                      // un scan ne peut pas être autre chose qu'un entrant => forcément un duplicatedMailData
                      this.form.patchValue({ expediteurId: duplicatedMailDatasFromiScan.expediteurId });
                      this.expediteurUserNeededToBeAdded = duplicatedMailDatasFromiScan.expediteurId
                        ? duplicatedMailDatasFromiScan.expediteurId
                        : null;
                      this.getUsersByServicesID(serviceProp);
                    } else if (this.form.value.typeEntrantSortant === 'E') {
                      if (duplicatedMailDatasFromiScan?.expediteurId || duplicatedMailDatasFromiScan?.expediteurIdiAdmin) {
                        const origin = duplicatedMailDatasFromiScan.expediteurIdiAdmin ? 'iAdmin' : 'iCourrier';
                        this.onSelectRecipientOrigin(origin).then(() => {
                          if (duplicatedMailDatasFromiScan.expediteurIdiAdmin) {
                            this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, duplicatedMailDatasFromiScan.expediteurIdiAdmin);
                          } else if (duplicatedMailDatasFromiScan.expediteurId) {
                            this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, duplicatedMailDatasFromiScan.expediteurId);
                          }
                        });
                      } else {
                        this.expediteurContactNeededToBeAdded = null;
                        this.filteredExpediteurs = [];
                      }
                    }
                  }
                  callback();
                });
              },
            ]);
          }
          if (this.createNewCourrierForIDelibe) {
            // dans le component parent on set dataMailCreation.mailType === 'S'
            this.pointIdFromIDelibe = +JSON.parse(localStorage.getItem('iCourrier_point_id_send'));
            this.iDelibeApi.getPointFullInfos(this.pointIdFromIDelibe).subscribe({
              next: (res) => {
                const pointInfos: Point = res;

                // Tout part du fait de s'il y a un serviceId
                if (pointInfos.serviceId) {
                  this.form.patchValue({ CreateMethod: 'FromIDelibe' });
                  this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === pointInfos.serviceId));

                  if (this.selectedOption) {
                    //Si on a une selectedOption ca veut dire que le service existe dans la liste :) donc on peut le setter dans le form ainsi que visuellement
                    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                    if (labelTreeHtml) {
                      labelTreeHtml[0].innerHTML = this.selectedOption.label;
                      this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
                    }
                    this.serviceProprietaireId = pointInfos.serviceId;
                    this.form.patchValue({ serviceProprietaireId: pointInfos.serviceId });
                    this.getUsersByServicesID(this.selectedOption.value);

                    this.getClassements().then(() => {
                      if (pointInfos.classementId) {
                        const doesClassificationIdExistsInList = this.codesclassementsLV.find((code) => code.value === pointInfos.classementId);

                        if (doesClassificationIdExistsInList) {
                          this.form.patchValue({ classementId: pointInfos.classementId });
                          this.getClasseur(this.form.value.classementId, null, null);
                        } else {
                          this.toastr.error('Le classement ne peut être retrouvé dans la liste des classements qui vous sont accessibles');
                        }
                      }
                    });
                  } else {
                    this.toastr.error('Le service ne peut être retrouvé dans la liste des services qui vous sont accessibles');
                  }
                }

                this.form.patchValue({
                  objet: pointInfos.objetSynthese,
                });
              },
            });
          }
          if (!this.mailId && !this.mail && !this.scan && !this.createNewCourrierForIDelibe) {
            // ici on est dans un create new
            this.getClassements();
            this.onSelectRecipientOrigin(this.form.value.recipientSource);
          }
          cb(null);
        },

        (cb) => {
          this.dataMatrice.type = this.typeEntrantSortant;
          this.getMatrice(this.dataMatrice);
          if (this.isNew && !this.scan) {
            this.dataService.setSidebarSmall(false);
          } else {
            this.dataService.setSidebarSmall(true);
          }
          cb(null);
        },
        (cb) => {
          this.spinner.hide();
          this.isLoaded = true;
          cb();
        },
      ],
      () => {
        //Selection automatique d'un service s'il n'en existe qu'un et un seul accessible à l'utilisateur
        if (this.isNew && this.serviceParent.length === 1 && this.serviceParent[0].children.length === 0) {
          const doesServiceExistsInList = _.first(this.servicesFusionned.filter((x) => x.value === this.serviceParent[0].value));
          if (!this.readOnly4Info && doesServiceExistsInList) {
            setTimeout(() => {
              this.select({ node: { value: this.serviceParent[0].value } });
              this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
            });
          }
        }
      }
    );
    // NOBODY TOUCH THIS FUNCTION
    this.dataService.attachementFileInfo.subscribe({
      next: (res) => {
        if (res && (res?.type || res?.size || res?.name)) {
          //s'il y a un res.type ou une size ou encore un name alors on a un objet
          this.attachements.push(res);
        }
      },
    });
    if (this.form) {
      this.formSubscription = this.form.valueChanges.subscribe({
        next: (val) => {
          if (val && !this.courrierFile && !val.objet) {
            // !val.objet parce que sinon le valueCHange proc a chaque modification de l'objet
            this.typeEntrantSortant = val.typeEntrantSortant;
            this.formState.emit({ form: this.form, isFormSubmit: this.isFormSubmit });
            this.formChange.emit(this.form.value);

            if (val.typeEntrantSortant === 'E' || val.typeEntrantSortant === 'S') {
              this.dateEcheance = val.dateEcheance;
            }
            if (val.dateDocument) {
              this.hasDateDocument = true;
            } else {
              this.hasDateDocument = false;
            }
            setTimeout(() => {
              if (
                val.typeEntrantSortant &&
                val.typeEntrantSortant !== null &&
                this.selectedOption &&
                val.dateEntree &&
                val.dateEntree !== null &&
                this.form.valid &&
                ((this.expediteurTabsActive === 'new' && this.canSaveContact) || this.expediteurTabsActive !== 'new')
              ) {
                this.isFormValid.emit(true);
              } else {
                this.isFormValid.emit(false);
              }
            }, 1000);
          } else {
            setTimeout(() => {
              if (
                val.typeEntrantSortant &&
                val.typeEntrantSortant !== null &&
                this.selectedOption &&
                val.dateEntree &&
                val.dateEntree !== null &&
                this.form.valid &&
                ((this.expediteurTabsActive === 'new' && this.canSaveContact) || this.expediteurTabsActive !== 'new')
              ) {
                this.isFormValid.emit(true);
              } else {
                this.isFormValid.emit(false);
              }
            }, 1000);
          }
        },
      });
    }
  }

  getDestinatairesMailAnswered(): Promise<boolean> {
    return new Promise((resolve) => {
      this.recipientsService.fetchMailRecipientFullInfos(this.mailId).subscribe({
        next: (res) => {
          this.destinatairesMailAnswered = res;
          resolve(true);
        },
      });
    });
  }

  patchServiceOnLoopInTreeSelect(serviceChosen): void {
    const allServicesToBeAdded = [];
    //pour chaque serviceId
    this.serviceParent.map((parent) => {
      //si le parentId correspond on push
      if (parent.id === serviceChosen) {
        allServicesToBeAdded.push(parent);
      } else {
        //Si pas on va devoir entrer dans les enfants
        if (parent.children && parent.children.length > 0) {
          recursive(serviceChosen, parent.children, allServicesToBeAdded);
        }
      }
    });
    this.treeSelect.value = allServicesToBeAdded;

    function recursive(serviceId, children, allServicesToBeAdded): void {
      children.map((child) => {
        if (child.id === serviceId) {
          allServicesToBeAdded.push(child);
        } else {
          if (child.children && child.children.length > 0) {
            recursive(serviceId, child.children, allServicesToBeAdded);
          }
        }
      });
    }
  }

  displayArchived(typeOfClassement, event): void {
    if (typeOfClassement === 'classeur') {
      this.getClasseur(this.form.value.classementId, event.checked);
    } else if (typeOfClassement === 'chemise') {
      this.getChemises(this.form.value.classeurId, event.checked);
    }
  }

  changeRef(): void {
    if (this.formNatureSource.value.afficherReferenceRecommande) {
      this.defaultRef = 'Oui';
    } else {
      this.defaultRef = 'Non';
    }
  }

  getMatrice(data): void {
    this.matrixService.getCheckMatrice(data).subscribe({
      next: (res) => {
        this.checkMatrice = res;
        this.checkValidatorsExpediteurs();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getUsersByServicesID(serviceID: number, fromEditContact?: boolean, userValue?): Promise<boolean> {
    return new Promise((resolve) => {
      this.contacts = [];
      this.userIDService = [];
      this.tempContact = [];
      if (serviceID) {
        async.waterfall(
          [
            (cb) => {
              this.servicesService.fetchServiceUsersIds(serviceID).subscribe({
                next: (ids: number[]) => {
                  ids.forEach((userId) => {
                    if (userId) {
                      this.userIDService.push(userId);
                    }
                  });
                  cb(null);
                },
              });
            },
            (cb) => {
              if (this.userIDService.length > 0) {
                this.usersService.fetchUsersFromiAdmin({ UserIds: this.userIDService.join(',') }).subscribe({
                  next: (res: UserDto[]) => {
                    res.forEach((user) => {
                      this.tempContact.push({
                        label: user.contactForUser.prenom + ' ' + user.contactForUser.nom,
                        value: user.contactForUser ? user.contactForUser.contactId : user.userId,
                        id: user.contactForUser ? user.contactForUser.contactId : user.userId,
                        adresse:
                          (user.contactForUser.adresse?.impression_Adresse ? user.contactForUser.adresse.impression_Adresse + ' ' : '') +
                          (user.contactForUser.adresse?.impression_codePostal ? user.contactForUser.adresse.impression_codePostal + ' ' : '') +
                          (user.contactForUser.adresse?.impression_Localite ? user.contactForUser.adresse.impression_Localite + ' ' : '') +
                          (user.contactForUser.adresse?.impression_Pays ? user.contactForUser.adresse.impression_Pays : ''),
                        typeContactID: user.contactForUser.typeId,
                        nameTypeContact: this.contactTypes.find((x) => {
                          return x.value === user.contactForUser.typeId;
                        })?.label,
                      });
                    });
                    cb(null);
                  },
                });
              } else {
                cb();
              }
            },
            (cb) => {
              this.contacts = _.sortBy(this.tempContact, 'label');
              //* Let's avoid to patch the user if we're duplicating an existing mail were the exp. SHOULD be the one on the duplicate mail
              if (!this.duplicatedMailIdFromiScan) {
                this.form.patchValue({
                  expediteurIdiAdmin: this.userInfos.contactId,
                });
              }
              cb();
            },
          ],
          () => {
            if (fromEditContact && !this.duplicatedMailIdFromiScan) {
              this.form.patchValue({ expediteurId: userValue });
              this.spinner.hide();
            }
            this.spinner.hide();
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }
  ngAfterViewInit(): void {
    if (this.stateDropdown && this.stateDropdown.filterViewChild) {
      this.stateDropdown.renderer.setAttribute(this.stateDropdown.filterViewChild.nativeElement, 'autocomplete', 'new-password');
    }
  }

  moveAutocomplete(): void {
    if (this.stateDropdown) {
      const random = 'nope-' + (Math.random() + 1).toString(36).substring(7);
      if (this.stateDropdown?.filterViewChild) {
        this.stateDropdown.renderer.setAttribute(this.stateDropdown.filterViewChild.nativeElement, 'autocomplete', random);
      }
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem('iCourrier_point_id_send');
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
    this.submitSubscription.unsubscribe();
    sessionStorage.removeItem('newCourrier');
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  checkEcheanceDate(): void {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (this.dateEcheance && this.dateEcheance !== null) {
      if (yesterday > this.dateEcheance) {
        this.toastr.warning(this.translater.translate('warningDueDateBeforeCurrentDay'), this.translater.translate('warning'));
      }
    }
  }
  receiveCanSaveContact(event): void {
    this.canSaveContact = event;
    if (
      this.form.value.typeEntrantSortant &&
      this.form.value.typeEntrantSortant !== null &&
      this.selectedOption &&
      this.form.value.dateEntree &&
      this.form.value.dateEntree !== null &&
      this.form.valid &&
      ((this.expediteurTabsActive === 'new' && this.canSaveContact) || this.expediteurTabsActive !== 'new')
    ) {
      this.isFormValid.emit(true);
    } else {
      this.isFormValid.emit(false);
    }
  }

  listenToSubmitEvent(): void {
    this.submitSubscription = this.globalSubmitE.subscribe({
      next: () => {
        if (this.expediteurTabsActive === 'new') {
          //C'est ici qu'on va d'abord devoir save l'expéditeur pour Ensuite accepter d'aller plus loin
          this.isSavingNewExpediteur.next();
        } else {
          if (this.isDuplicateMode) {
            this.duplicate();
          } else {
            this.onSubmit();
          }
        }
      },
    });
  }

  contactFormToBeSaved(event: { success: boolean; contact: Contact }): void {
    if (event.success) {
      // Quand on reçoit le success de la sauvegarde de l'expéditeur, on va devoir forcer la page à afficher la liste des expéditeurs iCourrier. En effet, un expéditeur créé ici sera FORCEMENT un expediteur iCourrier
      // Donc si on veut qu'il s'affiche (si jamais un soucis de sauvegarde arrive), on se doit de changer le visuel de la page
      this.spinner.show();
      // En premier lieu on va changer le type de recipientSource pour le forcer vers iCourrier et on va patcher l'information du contact créé
      this.form.patchValue({
        recipientSource: 'iCourrier',
        expediteurId: event.contact.id,
      });
      this.recipientSourceBoolean = true;
      // On va récupérer la liste de contacts. Comme le typeEntrantSortant est FORCEMENT 'E' (sinon on ne pourrait pas avoir accès à la création d'expéditeur), on sait que l'on va récupérer les contacts iCourrier.
      this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(this.f.serviceProprietaireId.value, event.contact.id).then(() => {
        // on change l'onglet vers les expéditeurs existants
        this.onChangeTabsExpediteurs('existing').then(() => {
          //on force les validateurs
          this.checkExpediteurRequiredForE();
          this.actionTabs[0].active = true;
          this.actionTabs[1].active = false;
          if (this.isDuplicateMode) {
            this.duplicate();
          } else {
            this.onSubmit();
          }
        });
      });
    }
  }

  initForm(): void {
    this.form = this.formBuilder.group({
      annexeNonScannee: new FormControl(false),
      annexeNonScanneeNombre: new FormControl(null),
      annexeDiffusee: new FormControl(false),
      aCompleter: new FormControl(null),
      typeEntrantSortant: new FormControl(this.mailType ? this.mailType : null, [Validators.required]),
      confidentiel: new FormControl(false),
      objet: new FormControl('', Validators.maxLength(4000)),
      dateEntree: new FormControl(new Date(), Validators.required),
      dateDocument: new FormControl(null),
      dateEcheance: new FormControl(null),
      datePostale: new FormControl(null),
      serviceProprietaireId: new FormControl(this.serviceProprietaireId ? this.serviceProprietaireId : null, Validators.required),
      expediteurId: new FormControl(null),
      expediteurIdiAdmin: new FormControl(null),
      expediteurLibre: new FormControl(''),
      refExpediteur: new FormControl(''),
      natureId: new FormControl(null),
      sourceId: new FormControl(null),
      statutId: new FormControl(null),
      boiteArchive: new FormControl(null),
      remarques: new FormControl(''),
      referenceRecommande: new FormControl(null),
      classementId: new FormControl(null),
      classeurId: new FormControl(null),
      chemiseId: new FormControl(null), //Attention, on a pas mis de required ici ssi il y a un classeur afin d'avoir un message d'erreur personnalisé dans le onSubmit
      NatureCustomDatas: new FormControl(null),
      CentreNumerisationId: new FormControl(null),
      DestinataireContactId: new FormControl(null),
      recipientSource: new FormControl('iCourrier'),
      lien: new UntypedFormGroup({
        linkCourrierId: new FormControl(null),
        typeLiaison: new FormControl(null),
      }),
      CreateMethod: new FormControl(),
    });
    this.recipientSourceBoolean = true; // linked to recipientSource
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  getAllCenterNums(): Promise<boolean> {
    return new Promise((resolve) => {
      this.numerisationCentersService.getGlobalCentreNumerisation().subscribe({
        next: (res) => {
          this.numerisations_center = [];
          if (res?.length > 0) {
            res.map((item) => {
              this.numerisations_center.push({ label: item.description, value: item.id, item: item });
            });
          } else {
            this.numerisations_center = [];
          }
          resolve(true);
        },
      });
    });
  }

  getUserInfo(): Promise<boolean> {
    return new Promise((resolve) => {
      this.meService.getUserInfo().subscribe({
        next: (response: UserInfo) => {
          this.userInfos = response;
          resolve(true);
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUserInfos'));
        },
      });
    });
  }

  public getUserData(id: number): Promise<boolean> {
    return new Promise((resolve) => {
      const data = {
        id: [id],
      };
      this.contactsService.fetchSearchContacts(data, 'iCourrier').subscribe({
        next: (res) => {
          this.userData = res[0];
          resolve(true);
        },
        error: () => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingContacts'));
        },
      });
    });
  }

  // utilisé pour getContactType
  getGroupsMembersOfContactIds(): Promise<boolean> {
    return new Promise((resolve) => {
      this.groupsService.getGroupesMembres({ contactIds: [this.userInfos.contactId] }).subscribe({
        next: (res: GroupsMembersDTO[]) => {
          this.groupsMemberUserConnected = res;
          resolve(true);
        },
        error: () => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingGroupMembers'));
        },
      });
    });
  }

  getContactType(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.contactsGlobalService.fetchContactTypes().subscribe({
        next: (response) => {
          const temp = [];
          response.map((item) => {
            //pour chaque type de contact on va devoir vérifier son groupe de visualisation
            // const isCheckGroupeVisuOk =
            //   !item.visualisationGereeParGroupeId ||
            //   (item.visualisationGereeParGroupeId &&
            //     this.groupsMemberUserConnected
            //       .map((group) => group.groupe.id)
            //       .includes(item.visualisationGereeParGroupeId));
            // isCheckGroupeVisuOk ? temp.push({ label: item.typeContact, value: item.id }) : null;
            temp.push({ label: item.typeContact, value: item.id });
          });
          this.contactTypes = _.sortBy(temp, 'label');
          resolve(true);
        },
        error: () => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingContactTypes'));
          this.spinner.hide();
          reject(false);
        },
      });
    });
  }

  public getConfiguration(): void {
    this.configService.fetchConfig().subscribe({
      next: (response) => {
        this.configuration = response;
        this.setConfigurationForForm();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  private setConfigurationForForm(): void {
    if (this.configuration.mails.obligationNature) {
      this.form.get('natureId').setValidators(Validators.required);
    }
    if (this.configuration.mails.obligationSource) {
      this.form.get('sourceId').setValidators(Validators.required);
    }
    if (!this.configuration.mails.hideConfirmNoDateDoc) {
      this.form.get('dateDocument').setValidators(Validators.required);
    }
    if (!this.configuration.mails.hideConfirmNoDateEntree) {
      this.form.get('dateEntree').setValidators(Validators.required);
    }
  }

  // get Services configuration for the connected user
  public getUserServices(): Promise<boolean> {
    return new Promise((resolve) => {
      forkJoin({
        userServices: this.meService.fetchMyOwnServices(),
      }).subscribe({
        next: (res) => {
          this.userServices = res.userServices;
          this.spinner.hide();
          resolve(true);
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
          this.spinner.hide();
        },
      });
    });
  }

  public getUserRightsMailsCreation(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.userInfos.encodageToutService) {
        this.getServiceList().then(() => {
          resolve(true);
          this.spinner.hide();
        });
      } else {
        this.mailsRightsService.fetchMailCreationRights().subscribe({
          next: (res: MailCreationRightDto[]) => {
            this.servicesCreation = [];
            let arrayParent = [];
            let arrayChild = [];
            arrayParent = res.filter((right) => right.serviceParentId === 0);
            arrayChild = res.filter((right) => right.serviceParentId !== 0);
            if (arrayParent?.length > 0) {
              // On va boucler, si un parent a des enfants & qu'au moins un a true a addmailentrant/sortant/interne, alors on peut voir le parent
              arrayParent.forEach((parent) => {
                if (arrayChild && arrayChild.length > 0) {
                  arrayChild.forEach((child) => {
                    if (parent.serviceId === child.serviceParentId && child.addMailEntrant) {
                      parent.addMailEntrantChild = true;
                    }
                    if (parent.serviceId === child.serviceParentId && child.addMailSortant) {
                      parent.addMailSortantChild = true;
                    }

                    if (parent.serviceId === child.serviceParentId && child.addMailInterne) {
                      parent.addMailInterneChild = true;
                    }
                  });
                }
              });
            }
            this.servicesCreation = arrayParent.concat(arrayChild);

            this.getServiceList().then(() => {
              resolve(true);
              this.spinner.hide();
            });
          },
          error: (err: HttpErrorResponse) => {
            console.error(err);
            this.spinner.hide();
          },
        });
      }
    });
  }

  public getUserRightsMailModification(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.courrier.mauvaisRoutage) {
        this.getServiceList().then(() => {
          resolve(true);
        });
      } else {
        this.meService.fetchMyOwnServices().subscribe({
          next: (res) => {
            this.servicesModification = res.filter((x) => {
              return x.refuserModification === false;
            });
            this.getServiceList().then(() => {
              resolve(true);
            });
          },
        });
      }
    });
  }

  // on change service take configuration and adapt configurations
  onServiceSelect(event, booleanChangeOnDropdown = false): void {
    const serviceId = event;
    this.serviceID = event;
    if (serviceId) {
      this.dataMatrice.svcPropId = serviceId;
      this.getMatrice(this.dataMatrice);
    }
    this.selectedUserService = this.userServices.find((service) => service.serviceId === serviceId);

    this.selectedService = this.services.find((serv) => {
      if (serv.id === serviceId) {
        return true;
      }
    });

    if (this.selectedUserService) {
      if (this.isNew) {
        if (this.selectedUserService.refuserCreationEntrant && this.f.typeEntrantSortant.value === 'E') {
          this.toastr.error(this.translater.translate('warningNoRightToCreateIncomingMail'));
          this.f.typeEntrantSortant.patchValue(null);
        }
        if (this.selectedUserService.refuserCreationSortant && this.f.typeEntrantSortant.value === 'S') {
          this.toastr.error(this.translater.translate('warningNoRightToCreateOncomingMail'));
          this.f.typeEntrantSortant.setValue(null);
        }
      }
      if (!this.isNew) {
        if (this.selectedUserService.refuserModification) {
          this.toastr.error(this.translater.translate('warningNoRightToModifyMail'));
          this.form.disable();
        } else {
          this.form.enable();
        }
      }
    }

    const filteredNatureList = [];
    const filteredSourceList = [];

    this.natureList.forEach((nature) => {
      if (nature.servicesAutorisesList?.length === 0 || nature.servicesAutorisesList?.includes(this.selectedService && this.selectedService.id)) {
        filteredNatureList.push(nature);
      }
    });
    this.natureListLV = [];
    filteredNatureList.forEach((item) => {
      this.natureListLV.push({ label: item.description, value: item.id });
    });
    this.natureListLV = _.sortBy(this.natureListLV, 'label');

    // Filter source contains ServiceProprietaireId
    this.sourceList.forEach((source) => {
      if (source.servicesAutorisesList?.length === 0 || source.servicesAutorisesList?.includes(this.selectedService && this.selectedService.id)) {
        filteredSourceList.push(source);
      }
    });
    this.sourceListLV = [];
    filteredSourceList.forEach((item) => {
      this.sourceListLV.push({ label: item.description, value: item.id, typeMail: item.typeMail });
    });
    this.sourceListLV = _.sortBy(this.sourceListLV, 'label');

    if (booleanChangeOnDropdown) {
      //Si on change a la main le service => il faut absolument empêcher que le classeur et la chemises ne restent!
      this.courrier ? (this.courrier.classeurId = null) : null;
      this.courrier ? (this.courrier.chemiseId = null) : null;
    }
    // unpatch classeur + chemise on change service + reload classeurs
    this.form.patchValue({
      classeurId: null,
      chemiseId: null,
    });
    this.getClasseur(this.form.value.classementId, this.classeurCheckArchived);
  }

  public checkValidatorsExpediteurs(): void {
    switch (this.typeEntrantSortant) {
      case 'E':
        this.checkExpediteurRequiredForE();
        break;
      case 'S':
        this.checkExpediteurRequiredForS();
        break;
      case 'I':
        this.checkExpediteurRequiredForI();
        break;
    }
  }

  checkExpediteurRequiredForS(): void {
    // Pour un sortant, il n'y a qu'une seule règle : obligation d'ajouter un expédiiteur d'iAdmin
    this.form.get('expediteurIdiAdmin').addValidators(Validators.required);
    this.form.get('expediteurIdiAdmin').updateValueAndValidity();
    this.form.get('expediteurId').clearValidators();
    this.form.get('expediteurId').updateValueAndValidity();
    this.form.get('expediteurLibre').clearValidators();
    this.form.get('expediteurLibre').updateValueAndValidity();
  }

  checkExpediteurRequiredForE(): void {
    const expId = this.f.expediteurId;
    const expiAdmin = this.f.expediteurIdiAdmin;
    const expLibre = this.f.expediteurLibre;
    if (this.checkMatrice?.expediteur?.obligatoire === true) {
      if (this.expediteurTabsActive === 'existing') {
        if (this.form.value.recipientSource === 'iCourrier') {
          expId.setValidators([Validators.required]);
          expiAdmin.setValidators(null);
        } else {
          expId.setValidators(null);
          expiAdmin.setValidators([Validators.required]);
        }
        expLibre.setValidators(null);
      } else if (this.expediteurTabsActive === 'new') {
        // Contact iCourrier obligatoire car on crée un nouveau contact
        expId.setValidators([Validators.required]);
        expiAdmin.setValidators(null);
        expLibre.setValidators(null);
      } else if (this.expediteurTabsActive === 'free') {
        expId.setValidators(null);
        expiAdmin.setValidators(null);
        expLibre.setValidators([Validators.required]);
      }
    } else {
      expId.setValidators(null);
      expiAdmin.setValidators(null);
      expLibre.setValidators(null);
    }
    expId.updateValueAndValidity();
    expiAdmin.updateValueAndValidity();
    expLibre.updateValueAndValidity();
  }

  checkExpediteurRequiredForI(): void {
    // Pour un Interne : on vérifie la matrice. Si celle-ci est obligatoire l'expéditeur iAdmin sera obligatoire
    const expId = this.f.expediteurId;
    const expiAdmin = this.f.expediteurIdiAdmin;
    const expLibre = this.f.expediteurLibre;
    if (this.checkMatrice?.expediteur?.obligatoire === true) {
      expiAdmin.setValidators([Validators.required]);
    } else {
      expiAdmin.setValidators(null);
    }
    expId.setValidators(null);
    expLibre.setValidators(null);
    expId.updateValueAndValidity();
    expiAdmin.updateValueAndValidity();
    expLibre.updateValueAndValidity();
  }

  /**
   * Submits the form data and performs necessary validations and checks before saving the mail.
   * If the form is valid, it checks if a binder is set and if a plastic sheet is chosen.
   * If the form is invalid, an error message is displayed.
   * If a binder is set and a plastic sheet is not chosen, an error message is displayed.
   * If the form is valid and the conditions are met, the mail is saved.
   *
   * @return {void} No return value
   */
  public onSubmit(): void {
    if (this.form.valid) {
      // After that we need to check if a binder is set.
      // If yes we need to check if there's a plastic sheet chosen. In fact a binder chosen can't be saved WITHOUT a plastic sheet
      // ICOUR-4129
      //! Attention, on a fait un check APRES le form.valid car
      // 1) On a pas mis de validateur sur la chemise vu que c'est uniquement en fonction de s'il y a une farde
      // 2) Afin d'avoir un message d'erreur personnalisé dans le onSubmit
      if ((this.form.value.classeurId && this.form.value.chemiseId) || !this.form.value.classeurId) {
        if (
          (this.form.value.lien.linkCourrierId && this.form.value.lien.typeLiaison) ||
          (!this.form.value.lien.linkCourrierId && !this.form.value.lien.typeLiaison)
        ) {
          this.spinner.show();
          // ici on peut gérer les informations directement dans le formulaire, car cela n'aura pas d'impact frontend même si la requête échoue
          if (!this.form.value.annexeNonScannee) {
            this.form.value.annexeNonScannee = false;
            this.form.value.annexeNonScanneeNombre = null;
            this.form.value.annexeDiffusee = false;
          }
          if (this.form.value.dateDocument && moment(this.form.value.dateDocument).isValid()) {
            this.form.value.dateDocument = moment(this.form.value.dateDocument).format('YYYY-MM-DD');
          }
          if (this.form.value.dateEcheance && moment(this.form.value.dateEcheance).isValid()) {
            this.form.value.dateEcheance = moment(this.form.value.dateEcheance).format('YYYY-MM-DD');
          }
          if (this.form.value.dateEntree && moment(this.form.value.dateEntree).isValid()) {
            this.form.value.dateEntree = moment(this.form.value.dateEntree).format('YYYY-MM-DD');
          }
          if (this.form.value.datePostale && moment(this.form.value.datePostale).isValid()) {
            this.form.value.datePostale = moment(this.form.value.datePostale).format('YYYY-MM-DD');
          }

          if (this.form.value.typeEntrantSortant === 'E') {
            if (this.expediteurTabsActive === 'existing') {
              this.form.value.expediteurLibre = null;

              if (this.form.value.recipientSource === 'iAdmin') {
                this.form.value.expediteurId = null;
                if (this.form.value.expediteurIdiAdmin?.id) {
                  this.form.value.expediteurIdiAdmin = this.form.value.expediteurIdiAdmin.id;
                }
              }

              if (this.form.value.recipientSource === 'iCourrier') {
                this.form.value.expediteurIdiAdmin = null;
                if (this.form.value.expediteurId?.id) {
                  this.form.value.expediteurId = this.form.value.expediteurId.id;
                }
              }
            } else {
              this.form.value.expediteurId = null;
              this.form.value.expediteurIdiAdmin = null;
            }
          } else {
            // Interne et sortant ne peuvent pas avoir d'expediteurId. Réservé à l'Entrant
            this.form.value.expediteurId = null;
            this.form.value.expediteurLibre = null;
          }

          // Une fois les non-breaking changes effectués, on va créer notre objet dataToSendBackend en cloneDeep afin d'effectuer les breaking-changes
          // En effet, si on modifiait ces données via this.form.value, cela casserait complètement le formulaire si une erreur survenait.
          const dataToSendBackend = lodash.cloneDeep(this.form.value);
          // Si on a ni lienCourrierId ni typeLiaison, alors on envoie simplement pas la variable lien
          if (!dataToSendBackend.lien.linkCourrierId && !dataToSendBackend.lien.typeLiaison) {
            delete dataToSendBackend.lien;
          }

          //Si on est dans la duplication via iScan, on doit rajouter cet objet
          if (this.duplicatedMailIdFromiScan) {
            dataToSendBackend.duplicateOption = {
              duplicateFromCourrierId: +this.duplicatedMailIdFromiScan,
              duplicateDestinataire: this.route.snapshot.queryParams.duplicateRecipients === 'true' ? true : false,
              duplicateAction: this.route.snapshot.queryParams.duplicateActions === 'true' ? true : false,
            };
          }

          this.isFormSubmit = true;
          this.formState.emit({ form: this.form, isFormSubmit: this.isFormSubmit });
          this.dataService.setCanLeaveEditor(true);
          if ((this.isNew && this.isNew === true) || this.mail) {
            if (!this.scan || this.mail) {
              if (!this.isAnswerMode) {
                if (this.attachements.length === 0) {
                  this.saveMail(dataToSendBackend, false);
                } else {
                  this.saveMailFull(dataToSendBackend);
                }
              } else {
                this.saveQuickAnswer(dataToSendBackend, false);
              }
            } else {
              this.saveMailWithScan(dataToSendBackend);
            }
          } else {
            this.updateMail(dataToSendBackend);
          }
        } else {
          this.toastr.error(this.translater.translate('error.pleaseSelectALinkedMailAndARelationTypeOrNothing'));
          this.spinner.hide();
        }
      } else {
        this.toastr.error(this.translater.translate('error.pleaseAddAPlasticSheetBecauseYouChoseABinder'));
        this.spinner.hide();
      }
    } else {
      this.toastr.error(this.translater.translate('pleaseFulfillRequiredFields'));
      this.spinner.hide();
    }
  }

  public saveMail(data: MailInsert, skipFalse?: boolean): void {
    this.checkWarningsAndErrorsOnSave(data).then((res) => {
      if (res) {
        this.mailsService.addMail(data, skipFalse).subscribe({
          next: (response: MailCreatedDTO) => {
            this.checkIfQueryNeedsToBeSentToIDelibe(response).then(() => {
              this.courrier = new MailDetails(response);
              this.getLocksAccess().then(() => {
                this.courrierIsSaved.emit(this.currentUserLockInfo);
                this.isCourrier = true;
                this.spinner.hide();
                this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailCreated'));
                if (this.courrier.typeEntrantSortant === 'S') {
                  sessionStorage.setItem('showModalDestinataire', '1');
                  sessionStorage.setItem('showModalDocument', '1');
                }
                if (this.courrier.workflowStartDefinitionId !== null) {
                  this.toastr.success(this.translater.translate('successAssociatedFlow'), this.translater.translate('successFlowIsAssociatedToMail'));
                }
                this.newMail.emit(response);
              });
            });
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(this.translater.translate('errorWhileSendingForm'));
          },
        });
      }
    });
  }
  public saveMailFull(data: MailInsert): void {
    const mailReturned = this.addMailAttachement(data);

    this.checkWarningsAndErrorsOnSave(mailReturned).then((res) => {
      if (res) {
        if (this.MailUniqueId) {
          data.MailUniqueId = this.MailUniqueId;
        }
        this.mailsService.addMailFull(data).subscribe({
          next: (response) => {
            this.checkIfQueryNeedsToBeSentToIDelibe(response).then(() => {
              this.courrier = new MailDetails(response);
              this.getLocksAccess().then(() => {
                this.courrierIsSaved.emit(this.currentUserLockInfo);
                this.isCourrier = true;
                this.spinner.hide();
                this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailCreated'));
                if (this.courrier.typeEntrantSortant === 'S') {
                  sessionStorage.setItem('showModalDestinataire', '1');
                  sessionStorage.setItem('showModalDocument', '1');
                }
                this.newMail.emit(response);
                this.dataService.setCurrentMail(null);
                if (this.mail) {
                  this.router.navigateByUrl('/private/ic/courriers-exchange');
                }
                if (this.courrier.workflowStartDefinitionId !== null) {
                  this.toastr.success(this.translater.translate('successAssociatedFlow'), this.translater.translate('successFlowIsAssociatedToMail'));
                }
              });
            });
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(this.translater.translate('errorWhileSendingForm'));
          },
        });
      }
    });
  }

  private checkIfQueryNeedsToBeSentToIDelibe(mailCreated): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.createNewCourrierForIDelibe) {
        forkJoin({
          createLinkICourrier: this.mailsLinksService.postLinkCourrierIdDelibeId(mailCreated.id, {
            pointId: this.pointIdFromIDelibe,
            type: 'deliberation',
          }),
          createLinkConnector: this.iDelibeApi.postLinkCourrierIdDelibeId([mailCreated.id], this.pointIdFromIDelibe),
        }).subscribe({
          next: () => {
            localStorage.removeItem('iCourrier_point_id_send');
            this.toastr.success(this.translater.translate('courrierLink.linkAdded'));
            resolve(true);
          },
        });
      } else {
        resolve(true);
      }
    });
  }

  public saveQuickAnswer(mail: MailInsert, skipFalse?: boolean): void {
    this.checkWarningsAndErrorsOnSave(mail).then((res) => {
      if (res) {
        if (this.attachements?.length > 0) {
          const mailReturned = this.addMailAttachement(mail);

          this.mailsReplyService.fullReplyMail(this.mailId, mailReturned, skipFalse).subscribe({
            next: (response) => {
              this.afterMailReply(response);
            },
            error: () => {
              this.spinner.hide();
              this.toastr.error(this.translater.translate('errorWhileSendingForm'));
            },
          });
        } else {
          this.mailsReplyService.quickReplyMail(this.mailId, mail, skipFalse).subscribe({
            next: (response) => {
              this.afterMailReply(response);
            },
            error: () => {
              this.spinner.hide();
              this.toastr.error(this.translater.translate('errorWhileSendingForm'));
            },
          });
        }
      }
    });
  }

  afterMailReply(response): void {
    this.courrier = response;
    this.getLocksAccess().then(() => {
      this.courrierIsSaved.emit(this.currentUserLockInfo);
      this.spinner.hide();
      this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailCreated'));
      if (this.courrier.typeEntrantSortant === 'S') {
        sessionStorage.setItem('showModalDestinataire', '1');
        sessionStorage.setItem('showModalDocument', '1');
      }
      if (this.courrier.workflowStartDefinitionId !== null) {
        this.toastr.success(this.translater.translate('successAssociatedFlow'), this.translater.translate('successFlowIsAssociatedToMail'));
      }
      localStorage.removeItem('isAnswer');
      localStorage.setItem('isAnswer', 'sortants');
      this.newMail.emit(response);
    });
  }

  public addMailAttachement(mail): MailInsert {
    mail.Files = this.attachements;
    for (const propName in mail) {
      if (mail[propName] === null || mail[propName] === undefined) {
        delete mail[propName];
      }
    }
    return mail;
  }

  public saveMailWithScan(mail: MailInsert): void {
    let mailWithScan: MailCreateScanLotFullParams;
    this.settingMailDatasForFullScan(mail).then((mailTransformed: MailCreateScanLotFullParams) => {
      mailWithScan = mailTransformed;
      this.checkWarningsAndErrorsOnSave(mail).then((res) => {
        if (res) {
          this.iCourrierScanService.createCompleteMailFromiScan(this.cleanObject(mailWithScan)).subscribe({
            next: (response) => {
              this.courrier = new MailDetails(response);
              this.isFormSubmit = true;
              this.formState.emit({ form: this.form, isFormSubmit: this.isFormSubmit });

              // Ensuite on va récupérer les droits d'affichages du courrier créé
              this.mailsService.searchMailsToAttach({ ids: [response.id] }).subscribe({
                next: (mails) => {
                  const channel = new BroadcastChannel('courrierCreatedForiScanChannel');
                  channel.postMessage({
                    messageId: 'mailCreated',
                    guid: mailWithScan.split,
                    canViewMail: mails[0].canViewMail,
                    objet: mails[0].objet,
                    id: mails[0].id,
                    scanLotCompleted: mailWithScan.scanLotCompleted,
                  });
                  channel.close();
                  this.getLocksAccess().then(() => {
                    this.courrierIsSaved.emit(this.currentUserLockInfo);
                    this.spinner.hide();
                    this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailCreated'));
                    if (this.courrier.workflowStartDefinitionId !== null) {
                      this.toastr.success(
                        this.translater.translate('successAssociatedFlow'),
                        this.translater.translate('successFlowIsAssociatedToMail')
                      );
                    }
                    this.router.navigateByUrl('/private/ic/tabs/' + response.id, {
                      state: { origin: 'fromScan' },
                    });
                  });
                },
              });
            },
            error: () => {
              this.spinner.hide();
              this.toastr.error(this.translater.translate('errorWhileSendingForm'));
            },
          });
        }
      });
    });
  }

  settingMailDatasForFullScan(mail: MailInsert): Promise<MailCreateScanLotFullParams> {
    return new Promise((resolve) => {
      const mailWithScan = new MailCreateScanLotFullParams(mail);
      mailWithScan.scanLot = this.scan.scanGuid;
      mailWithScan.split = this.scan.splitGuid;
      mailWithScan.scanLotCompleted = this.scan.finished;
      mailWithScan.fileDescription = this.scan.file?.description;

      this.iScanApiService.getIscanData(this.scan.scanGuid).subscribe({
        next: (scanData) => {
          const index = scanData.splits.findIndex((split) => split.guid === this.scan.splitGuid);
          const metaData = scanData.splits[index]?.mainCode;
          mailWithScan.barCode = metaData;
          return resolve(mailWithScan);
        },
      });
    });
  }

  public updateMail(data: MailInsert): void {
    async.waterfall([
      (cb) => {
        let currentServices = [];
        currentServices = this.servicesFusionned.filter((x) => x.value === data.serviceProprietaireId);
        if (data['aCompleter']) {
          this.confirmationService.confirm({
            message:
              currentServices.length > 0
                ? this.translater.translate('isDocumentFullAndForService', { value: currentServices[0].description })
                : this.translater.translate('isDocumentFull'),
            icon: 'bi bi-exclamation-triangle',
            key: 'confirmCourrierComplete',
            accept: () => {
              data.aCompleter = false;
              cb(null);
            },
            reject: () => {
              data.aCompleter = true;
              cb(null);
            },
          });
        } else {
          cb(null);
        }
      },
      () => {
        this.spinner.show();
        data.id = this.mailId;
        this.checkWarningsAndErrorsOnSave(data).then((res) => {
          if (res) {
            this.mailsService.updateMail(this.mailId, data, true).subscribe({
              next: (response) => {
                this.courrier = new MailDetails(response);
                this.getLocksAccess().then(() => {
                  this.courrierIsSaved.emit(this.currentUserLockInfo);
                  this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailModified'));
                  this.newMail.emit(response);
                  this.router.navigateByUrl('/private/ic/courriers/' + localStorage.getItem('activeCategoryCourrier') + '/' + this.mailId);
                  this.spinner.hide();
                });
              },
              error: () => {
                this.spinner.hide();
                this.toastr.error(this.translater.translate('errorWhileSendingForm'));
              },
            });
          }
        });
      },
    ]);
  }

  checkWarningsAndErrorsOnSave(data): Promise<boolean> {
    return new Promise((resolve) => {
      const errorArray = [];
      const warningArray = [];

      if (this.checkMatrice.boiteArchive.obligatoire && data.boiteArchive === null) {
        errorArray.push(this.translater.translate('mandatoryArchiveBox'));
      }

      if (this.checkMatrice.codeClassement.obligatoire && data.classementId === null) {
        errorArray.push(this.translater.translate('mandatoryClassification'));
      }

      if ((this.checkMatrice.dateDocument.obligatoire || !this.configuration.mails.hideConfirmNoDateDoc) && data.dateDocument === null) {
        errorArray.push(this.translater.translate('mandatoryDocumentDate'));
      }

      if (!this.configuration.mails.hideConfirmNoDateEntree && data.dateEntree === null) {
        if (data.typeEntrantSortant === 'S') {
          errorArray.push(this.translater.translate('mandatoryExitDate'));
        } else {
          errorArray.push(this.translater.translate('mandatoryEntryDate'));
        }
      }

      if (this.checkMatrice.dateEcheance.obligatoire && data.dateEcheance === null) {
        errorArray.push(this.translater.translate('mandatoryDueDate'));
      }

      if (this.checkMatrice.expediteur.obligatoire && data.expediteur === null) {
        errorArray.push(this.translater.translate('mandatorySender'));
      }

      if ((this.checkMatrice.nature.obligatoire || this.configuration.mails.obligationNature) && data.natureId === null) {
        errorArray.push(this.translater.translate('mandatoryNature'));
      }

      if ((this.checkMatrice.source.obligatoire || this.configuration.mails.obligationSource) && data.sourceId === null) {
        errorArray.push(this.translater.translate('mandatorySource'));
      }

      if (this.checkMatrice.objet.obligatoire && data.objet === '') {
        errorArray.push(this.translater.translate('mandatoryObject'));
      }

      if (this.checkMatrice.refExpediteur.obligatoire) {
        errorArray.push(this.translater.translate('mandatorySenderReference'));
      }

      if (this.checkMatrice.refRecommande.obligatoire) {
        errorArray.push(this.translater.translate('mandatoryRegisteredMailReference'));
      }

      if (this.checkMatrice.remarques.obligatoire && data.remarques === '') {
        errorArray.push(this.translater.translate('mandatoryRemark'));
      }

      if (data.classementId !== null && data.classeurId !== null && data.chemiseId === null) {
        errorArray.push(this.translater.translate('youHaveToChooseAPLasticLiner'));
      }

      if (errorArray.length > 0) {
        errorArray.map((error) => {
          this.toastr.error(error);
        });
      } else {
        if (this.checkMatrice.boiteArchive.avertissement && data.boiteArchive === null) {
          warningArray.push(this.translater.translate('recommendedArchiveBox'));
        }
        if (this.checkMatrice.codeClassement.avertissement && data.classementId === null) {
          warningArray.push(this.translater.translate('recommendedClassification'));
        }
        if (this.checkMatrice.dateDocument.avertissement && data.dateDocument === null) {
          warningArray.push(this.translater.translate('recommendedDocumentDate'));
        }
        if (this.checkMatrice.dateEcheance.avertissement && data.dateEcheance === null) {
          warningArray.push(this.translater.translate('recommendedDueDate'));
        }
        if (this.checkMatrice.expediteur.avertissement && data.expediteur === null) {
          warningArray.push(this.translater.translate('recommendedSender'));
        }
        if (this.checkMatrice.nature.avertissement && data.natureId === null) {
          warningArray.push(this.translater.translate('recommendedNature'));
        }
        if (this.checkMatrice.source.avertissement && data.sourceId === null) {
          warningArray.push(this.translater.translate('recommendedSource'));
        }
        if (this.checkMatrice.objet.avertissement && data.objet === '') {
          warningArray.push(this.translater.translate('recommendedObject'));
        }
        if (this.checkMatrice.refExpediteur.avertissement) {
          warningArray.push(this.translater.translate('recommendedSenderReference'));
        }
        if (this.checkMatrice.refRecommande.avertissement) {
          warningArray.push(this.translater.translate('recommendedRegisteredMailReference'));
        }
        if (this.checkMatrice.remarques.avertissement && data.remarques === '') {
          warningArray.push(this.translater.translate('recommendedRemark'));
        }

        if (warningArray.length > 0) {
          warningArray.map((warn) => {
            this.toastr.warning(warn);
          });
        }
        if (errorArray.length === 0) {
          return resolve(true);
        } else {
          return null;
        }
      }
    });
  }

  getNaturesList(): Promise<boolean> {
    return new Promise((resolve) => {
      this.natureListLV = [];
      this.naturesService.fetchNatures().subscribe({
        next: (response) => {
          this.natureList = response;
          response.map((item) => {
            this.natureListLV.push({ label: item.description, value: item.id });
          });
          this.natureListLV = _.sortBy(this.natureListLV, 'label');
          resolve(true);
        },
        error: () => {
          this.spinner.hide();
        },
      });
    });
  }

  getServiceList(courrier?: Mail | MailDetails): Promise<boolean> {
    return new Promise((resolve) => {
      this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
        next: (response) => {
          let servicesFiltered = [];
          if (this.isNew) {
            if (this.userInfos.encodageToutService) {
              servicesFiltered = response.map((item) => {
                return { ...item, selectable: true, serviceId: item.id };
              });
            } else {
              // on affiche uniquement les services de l'utilisateur
              // Si type entrant sortant, on filtre la liste des services si il a le droit de création
              if (this.mailType) {
                switch (this.mailType) {
                  case 'E':
                    servicesFiltered = [];
                    this.servicesCreation.map((item) => {
                      item.selectable = item.addMailEntrant === true || item.addMailEntrantChild === true ? true : false;
                      servicesFiltered.push(item);
                    });
                    break;
                  case 'S':
                    servicesFiltered = [];
                    this.servicesCreation.map((item) => {
                      item.selectable = item.addMailSortant === true || item.addMailSortantChild === true ? true : false;
                      servicesFiltered.push(item);
                    });
                    break;
                  case 'I':
                    servicesFiltered = [];
                    this.servicesCreation.map((item) => {
                      item.selectable = item.addMailInterne === true || item.addMailInterneChild === true ? true : false;
                      servicesFiltered.push(item);
                    });
                    break;
                  default:
                    break;
                }
              } else {
                this.servicesCreation.map((item) => {
                  item.selectable = item.addMailInterne === true || item.addMailInterneChild === true ? true : false;
                  servicesFiltered.push(item);
                });
              }
            }
          } else {
            if (this.courrier.mauvaisRoutage || this.userInfos.distributionToutService) {
              servicesFiltered = response.map((item) => {
                return { ...item, selectable: true, serviceId: item.id };
              });
            } else {
              this.servicesModification.map((item) => {
                item.selectable = true;
                servicesFiltered.push(item);
              });
              // Si on est dans une modification il faut absolument ajouter le service du courrier afin qu'il puisse être précoché et ne pas empêcher la modification
              if (!servicesFiltered.find((item) => item.serviceId === this.courrier.serviceProprietaireId)) {
                // S'il doit être ajouté, on va simplement vérifier si son parent direct est dans la liste. Si son parent direct n'est pas dans la liste, on va l'ajouter avec un parentId === null pour qu'il s'affiche tout seul.
                const mailServiceToBeAdded = response.find((item) => item.id === this.courrier.serviceProprietaireId);
                // if (mailServiceToBeAdded.parentId && !servicesFiltered.find((item) => item.id === mailServiceToBeAdded.parentId)) {
                //   servicesFiltered.push({ ...mailServiceToBeAdded, serviceId: mailServiceToBeAdded.id, selectable: true, parentId: null });
                // } else {
                servicesFiltered.push({ ...mailServiceToBeAdded, serviceId: mailServiceToBeAdded.id, selectable: true });
                // }
              }
            }
          }
          this.services = response;

          let arrayTransformed = [];
          response.map((item) => {
            servicesFiltered.forEach((serviceFilter) => {
              if (serviceFilter.serviceId === item.id) {
                item.selectable = serviceFilter.selectable;
                item.value = item.id;
                item.label = item.description;
                arrayTransformed.push(item);
              }
            });
          });

          //AVA
          arrayTransformed = arrayTransformed.filter((service) => service.selectable);
          const serviceIdsUserHasAccessTo = arrayTransformed
            .filter((service) => service.selectable)
            .map((service) => {
              return service.id;
            });
          const datasForService = manageServicesSetAsTreeSelect(response, this.translater, serviceIdsUserHasAccessTo);
          this.serviceParent = datasForService.servicesForSingleCheck;
          this.servicesOnlyParent = returnOnlyParentServices(arrayTransformed);

          this.servicesFusionned = manageServicesToBeMerged(response);

          if (courrier && !this.readOnly4Info && this.servicesFusionned.length > 0) {
            this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === courrier.serviceProprietaireId));
            const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
            labelTreeHtml[0].innerHTML = this.selectedOption.label;
            this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
          }

          if (courrier?.serviceProprietaire && (this.isAnswerMode || this.mailId !== null)) {
            this.onServiceSelect(courrier.serviceProprietaire.id);
          }
          resolve(true);
        },
        error: () => {
          this.spinner.hide();
        },
      });
    });
  }

  getStatutList(): void {
    this.documentsService.getDocumentsStatutes().subscribe({
      next: (response) => {
        this.statutList = response;
        const defaultEntrant = this.statutList.find((statut) => statut.defaultEntrant === true && statut.notUsed === false);
        const defaultSortant = this.statutList.find((statut) => statut.defaultSortant === true && statut.notUsed === false);
        response.map((item) => {
          if (item.notUsed === false) {
            this.statutListLV.push({ label: item.description, value: item.id, ordre: item.ordreAffichage });
          }
        });
        this.statutListLV = _.sortBy(this.statutListLV, 'label');
        if (this.f.typeEntrantSortant.value === 'S') {
          if (defaultSortant) {
            this.f.statutId.patchValue(defaultSortant.id);
          }
        }
        if (this.f.typeEntrantSortant.value === 'E') {
          if (defaultEntrant) {
            this.f.statutId.patchValue(defaultEntrant.id);
          }
        }
        this.f.typeEntrantSortant.valueChanges.subscribe({
          next: (typeESI) => {
            if (typeESI) {
              this.typeEntrantSortant = typeESI;

              switch (typeESI) {
                case 'E':
                  if (defaultEntrant) {
                    this.f.statutId.patchValue(defaultEntrant?.id);
                  }

                  this.userServices.map((s) => {
                    if (s.refuserCreationEntrant) {
                      this.serviceParent.filter((serv) => serv.id !== s.serviceId);
                    }
                  });
                  this.form.patchValue({ recipientSource: 'iAdmin' });
                  this.recipientSourceBoolean = false;
                  break;
                case 'S':
                  if (defaultSortant) {
                    this.f.statutId.patchValue(defaultSortant?.id);
                  }
                  //* Let's avoid to change those vars if we already have a duplicated mail because expediteur and status will have to be patched with the values of the duplicated mail!
                  if (this.userInfos && !this.duplicatedMailIdFromiScan) {
                    this.form.patchValue({
                      expediteurIdiAdmin: this.userInfos.contactId,
                      statutId: defaultSortant?.id,
                    });
                  }
                  this.userServices.map((s) => {
                    if (s.refuserCreationSortant) {
                      if (this.serviceParent?.length > 0) {
                        this.serviceParent.filter((serv) => serv.id !== s.serviceId);
                      }
                    }
                  });
                  break;
                case 'I':
                  if (!this.duplicatedMailIdFromiScan) {
                    this.form.patchValue({ expediteurIdiAdmin: this.userInfos.contactId });
                  }
                  break;

                default:
                  break;
              }
              this.f.statutId.updateValueAndValidity();
            }
          },
        });
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getSourcelist(): Promise<boolean> {
    return new Promise((resolve) => {
      this.sourceListLV = [];
      this.sourcesService.fetchSources().subscribe({
        next: (response) => {
          response.map((item) => {
            this.sourceListLV.push({ label: item.description, value: item.id, typeMail: item.typeMail });
          });
          this.sourceListLV = _.sortBy(this.sourceListLV, 'label');
          this.sourceListLV = _.uniq(this.sourceListLV, 'label');
          this.sourceList = response;
          resolve(true);
        },
        error: () => {
          this.spinner.hide();
        },
      });
    });
  }

  private initializeErrors(): void {
    this.errorService
      .getErrors()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (errors) => {
          this.openErrorModal(errors, 'warningMode');
        },
      });
  }

  public openErrorModal(messages: AllErrorResponse[], mode: string): void {
    this.dialogService.open(HttpErrorModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Avertissement',
      baseZIndex: 1000,
      data: {
        messages: messages,
        mode: mode,
      },
    });
  }

  getLocale4Calendar(): void {
    this.translationService.getCalendartranslate('fr').subscribe({
      next: (response) => {
        this.locale4Calendar = response;
      },
    });
  }
  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
  }

  public openGlobalModal(title: string, message: string): void {
    this.dialogService.open(GlobalModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: title,
      baseZIndex: 1000,
      data: {
        message: message,
        title: title,
      },
    });
  }

  dragAttachement(event): void {
    this.attachements = [];
    this.attachements = event.currentFiles;
  }

  public onFormChange(): void {
    if (this.form.valid && this.selectedOption) {
      this.canSubmit.emit(true);
    } else {
      this.canSubmit.emit(false);
    }
  }
  getMail(): void {
    this.mailsService.fetchMailDetails(this.mailId).subscribe({
      next: (response: MailFullInfosDTO) => {
        this.tempMail = new Mail(response);
        if (this.readOnly4Info) {
          // Si on est en readonly alors on aura besoin d'afficher les bacs et les prises en charge
          this.getBacs();
          if (this.tempMail.priseEnChargeInfo?.demandeurContactId) {
            this.contactsService.getLowInformationsContactsiAdmin({ id: [this.tempMail.priseEnChargeInfo.demandeurContactId] }).subscribe({
              next: (contactFound) => {
                if (contactFound.length) {
                  this.tempMail.priseEnChargeInfo.demandeurContactLabel =
                    (contactFound[0].prenom ? contactFound[0].prenom : '') + ' ' + (contactFound[0]?.nom ? contactFound[0]?.nom : '');
                } else {
                  this.tempMail.priseEnChargeInfo.demandeurContactLabel = '/';
                }
              },
            });
          }
        }
        //* JIRA 2943 => Pas besoin de le faire ici comme de base l'expéditeur du mail devient le destinataire et il semblerait incongru que s'il est inactif qu'il se réponde a lui même!
        if (this.isAnswerMode && this.isNew) {
          this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === this.tempMail.serviceProprietaireId));
          if (!this.readOnly4Info) {
            if (this.selectedOption) {
              const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
              labelTreeHtml[0].innerHTML = this.selectedOption.label;
              this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
            }
          }
          const answerTextParams = this.configuration.mails.repondrePrefixe ? this.configuration.mails.repondrePrefixe : '';
          // Si c'est une réponse, dateEntree & Document sont la date du jour
          this.form.patchValue({
            annexeNonScannee: response.annexeNonScannee ? response.annexeNonScannee : '',
            annexeNonScanneeNombre: response.annexeNonScanneeNombre ? response.annexeNonScanneeNombre : null,
            annexeDiffusee: response.annexeDiffusee ? response.annexeDiffusee : '',
            aCompleter: response.aCompleter ? response.aCompleter : false,
            typeEntrantSortant: this.mailType,
            confidentiel: response.confidentiel ? response.confidentiel : '',
            dateEntree: moment().toDate(),
            dateDocument: moment().toDate(),
            dateEcheance: null,
            datePostale: response.datePostale !== null ? moment(response.datePostale).toDate() : null,
            refExpediteur: response.refExpediteur ? response.refExpediteur : '',
            objet: response.objet ? answerTextParams + response.objet : '',
            serviceProprietaireId: response.serviceProprietaireId ? response.serviceProprietaireId : null,
            classementId: response.classementId ? response.classementId : null,
            classeurId: response.classeurId ? response.classeurId : null,
            chemiseId: response.chemiseId ? response.chemiseId : null,
            CentreNumerisationId: response.centreNumerisationId && this.mailType !== 'S' ? response.centreNumerisationId : null,
          });
          this.getClassements('isFromUpdate'); //besoin du patch de value avant de get
          //ICOUR-4024
          if (this.typeEntrantSortant === 'S' || this.typeEntrantSortant === 'I') {
            //Si la réponse est un sortant => on répond a un entrant
            //  L'expéditeur est l'utilisateur connecté
            // Le destinataire est l'expéditeur du courrier entrant
            // (idem pour un interne, on garde la même analyse)
            this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(response.serviceProprietaireId).then(() => {
              if (this.userInfos) {
                this.form.patchValue({ expediteurIdiAdmin: this.userInfos.contactId });
              }
            });
          } else if (this.typeEntrantSortant === 'E') {
            //Si la reponse est un entrant => on répond a un sortant
            // L'expéditeur est le destinataire principal du courrier répondu (sauf un service)
            // Si c'est un contact tout roule (contactId || contactIdiAdmin)
            // Si c'est un libre tout roule (on l'affiche dans l'expediteur libre)
            //Le destinataire est l'expéditeur du courrier répondu
            const mainDestinataire = this.destinatairesMailAnswered.filter((dest) => !dest.isService).find((x) => x.principal);
            if (mainDestinataire) {
              if (mainDestinataire.contactiAdminId || mainDestinataire.contactId) {
                this.onSelectRecipientOrigin(mainDestinataire.contactiAdminId ? 'iAdmin' : 'iCourrier').then(() => {
                  if (mainDestinataire.contactiAdminId) {
                    this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, mainDestinataire.contactiAdminId).then((res) => {
                      if (res === false) {
                        this.toastr.warning(
                          this.translater.translate('editCourrier.contactInMailAnsweredNotAvailableInListOfContacts'),
                          this.translater.translate('warning')
                        );
                      }
                    });
                  } else if (mainDestinataire.contactId) {
                    this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, mainDestinataire.contactId).then((res) => {
                      if (res === false) {
                        this.toastr.warning(
                          this.translater.translate('editCourrier.contactInMailAnsweredNotAvailableInListOfContacts'),
                          this.translater.translate('warning')
                        );
                      }
                    });
                  }
                });
              } else if (mainDestinataire.libre) {
                this.setTabExpediteurToFree();
                this.form.patchValue({
                  expediteurId: null,
                  expediteurIdiAdmin: null,
                  expediteurLibre: mainDestinataire.libre,
                });
              }
            } else {
              this.form.patchValue({ expediteurId: null, expediteurIdiAdmin: null, expediteurLibre: null });
              this.filteredExpediteurs = [];
              this.toastr.warning(
                this.translater.translate('editCourrier.mailYouAnsweredToHasNoMainRecipientOrIsAService'),
                this.translater.translate('warning')
              );
            }
          }
        } else {
          // si ce n'est pas une réponse on patch ici exp, showREf etc
          this.courrier = new MailDetails(response);
          this.getUserRightsMailModification().then(() => {
            if (this.readOnly4Info) {
              //si on est en readonly alors on aura besoin d'afficher les prises en charge
              if (this.courrier.priseEnChargeInfo?.demandeurContactId) {
                this.contactsService.getLowInformationsContactsiAdmin({ id: [this.courrier.priseEnChargeInfo.demandeurContactId] }).subscribe({
                  next: (contactsFound) => {
                    if (contactsFound.length) {
                      this.courrier.priseEnChargeInfo.demandeurContactLabel =
                        (contactsFound[0].prenom ? contactsFound[0].prenom : '') + ' ' + (contactsFound[0]?.nom ? contactsFound[0]?.nom : '');
                    } else {
                      this.courrier.priseEnChargeInfo.demandeurContactLabel = '/';
                    }
                  },
                });
              }
            }
            this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === this.tempMail.serviceProprietaireId));
            if (!this.readOnly4Info) {
              if (this.selectedOption) {
                const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                labelTreeHtml[0].innerHTML = this.selectedOption.label;
                this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
              }
            }

            if (!this.mailType) {
              this.mailType = response.typeEntrantSortant;
            }
            if (this.courrier.typeEntrantSortant === 'E') {
              this.actionTabs.push({ header: 'newSender', id: 'new', active: false });
              this.actionTabs.push({ header: 'freeSender', id: 'free', active: false });
              this.actionTabs = _.uniq(this.actionTabs, 'id');
              if (this.courrier.expediteurLibre && this.courrier.expediteurLibre !== '') {
                this.setTabExpediteurToFree();
              }
            } else {
              const tempIndex = this.actionTabs.map((x) => x.id).indexOf('free');
              if (tempIndex > -1) {
                this.actionTabs.splice(tempIndex, 1);
              }
              const tempIndex2 = this.actionTabs.map((x) => x.id).indexOf('new');
              if (tempIndex2 > -1) {
                this.actionTabs.splice(tempIndex2, 1);
              }
            }
            //translation of actionTabs
            this.actionTabs.map((tab) => {
              tab.header = this.translater.translate(tab.header);
            });

            this.getLinks(this.courrier.id);
            this.getTagsByMail(this.courrier);
            this.getStatusByMail(this.courrier);

            this.form.patchValue({
              annexeNonScannee: response.annexeNonScannee ? response.annexeNonScannee : '',
              annexeNonScanneeNombre: response.annexeNonScanneeNombre ? response.annexeNonScanneeNombre : null,
              annexeDiffusee: response.annexeDiffusee ? response.annexeDiffusee : '',
              aCompleter: response.aCompleter ? response.aCompleter : false,
              typeEntrantSortant: response.typeEntrantSortant ? response.typeEntrantSortant : null,
              confidentiel: response.confidentiel ? response.confidentiel : '',
              dateEntree: response.dateEntree !== null ? moment(response.dateEntree).toDate() : null,
              dateDocument: response.dateDocument !== null ? moment(response.dateDocument).toDate() : null,
              dateEcheance: response.dateEcheance !== null ? moment(response.dateEcheance).toDate() : null,
              datePostale: response.datePostale !== null ? moment(response.datePostale).toDate() : null,
              refExpediteur: response.refExpediteur ? response.refExpediteur : '',
              objet: response.objet ? response.objet : '',
              serviceProprietaireId: response.serviceProprietaireId ? response.serviceProprietaireId : null,
              natureId: response.natureId ? response.natureId : null,
              sourceId: response.sourceId ? response.sourceId : null,
              statutId: response.statutId ? response.statutId : null,
              classementId: response.classementId ? response.classementId : null,
              classeurId: response.classeurId ? response.classeurId : null,
              chemiseId: response.chemiseId ? response.chemiseId : null,
              boiteArchive: response.boiteArchive ? response.boiteArchive : null,
              remarques: response.remarques ? response.remarques : null,
              referenceRecommande: response.referenceRecommande,
              CentreNumerisationId: response.centreNumerisationId && response.typeEntrantSortant !== 'S' ? response.centreNumerisationId : null,
            });
            if (response.typeEntrantSortant !== 'E') {
              // Si 'S' ou 'I'
              this.getUsersByServicesID(response.serviceProprietaireId).then(() => {
                this.form.patchValue({ expediteurIdiAdmin: response.expediteurIdiAdmin ?? null });
                //* JIRA 2943 On va ajouter l'expediteur s'il n'est pas dans la liste des contacts
                if (response.expediteurIdiAdmin && !this.contacts.find((x) => x.value === response.expediteurIdiAdmin)) {
                  this.usersService.fetchUsersFromiAdmin({ UserId: [response.expediteurIdiAdmin] }).subscribe({
                    next: (res: UserDto[]) => {
                      this.contacts.push({
                        label: res[0].contactForUser.prenom + ' ' + res[0].contactForUser.nom,
                        value: res[0].contactForUser ? res[0].contactForUser.contactId : res[0].userId,
                        adresse:
                          (res[0].contactForUser.adresse?.impression_Adresse ? res[0].contactForUser.adresse.impression_Adresse + ' ' : '') +
                          (res[0].contactForUser.adresse?.impression_codePostal ? res[0].contactForUser.adresse.impression_codePostal + ' ' : '') +
                          (res[0].contactForUser.adresse?.impression_Localite ? res[0].contactForUser.adresse.impression_Localite + ' ' : '') +
                          (res[0].contactForUser.adresse?.impression_Pays ? res[0].contactForUser.adresse.impression_Pays : ''),
                        typeContactID: res[0].contactForUser.typeId,
                      });
                      this.contacts = _.sortBy(this.contacts, 'label');
                    },
                  });
                }
              });
            } else {
              // Si c'est un 'E'
              const origin = response.expediteurIdiAdmin || response.expediteurLibre ? 'iAdmin' : 'iCourrier';
              this.onSelectRecipientOrigin(origin).then(() => {
                if (response.expediteurIdiAdmin) {
                  this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, response.expediteurIdiAdmin);
                } else if (response.expediteurId) {
                  this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, response.expediteurId);
                } else if (response.expediteurLibre) {
                  this.form.patchValue({ expediteurLibre: response.expediteurLibre });
                }
              });
            }
            this.getClassements('isFromUpdate');
            this.checkForComplementaryData(response.natureId);
            let currentSource = [];
            this.sourcesService.fetchSources().subscribe({
              next: (response) => {
                currentSource = response.filter((x) => x.id === this.courrier.sourceId);

                if (currentSource.length > 0) {
                  this.showRefRecommanded = currentSource[0]['afficherReferenceRecommande'];
                }
              },
              error: () => {
                this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingSources'));
              },
            });
          });
        }
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingMailById'));
      },
    });
  }

  getStatusByMail(courrier): void {
    this.statutGlobalLV = [];
    this.statutGlobal = [];
    this.form.addControl('lastStatusTransition', new FormControl(null));
    this.globalSpecificStatutesService.getGlobalStatus().subscribe({
      next: (res: GlobalStatusDTO[]) => {
        if (res.length > 0) {
          this.statutGlobal = res;
          this.form.patchValue({
            lastStatusTransition: courrier.lastStatusTransition,
          });
          res.map((item) => {
            if (courrier['lastStatusTransition'] && courrier['lastStatusTransition']['globalStatusId'] === item.id) {
              this.courrier['statusGlobalName'] = item.description;
              this.courrier['statusGlobalBackground'] = item.color;
              this.courrier['statusGlobalColor'] = this.getOppositeColor(item.color);
            }
            this.statutGlobalLV.push({ label: item.description, value: item.id, color: item.color });
          });
        }
      },
    });
  }

  getTagsByMail(courrier): void {
    this.tags = [];
    this.tagsCourrier = [];
    this.multipleStatutesService.getMultipleStatus().subscribe({
      next: (res: MultipleStatutesDTO[]) => {
        if (res?.length > 0) {
          res.map((item) => {
            this.tags.push({ label: item.description, value: item.id, color: item.color, notUsed: item.notUsed });
          });
        }
        this.tags = [...this.tags];
        this.multipleStatutesService.getMailMultipleStatutes(courrier.id).subscribe({
          next: (res: MailMultipleStatutesDTO[]) => {
            if (res.length > 0) {
              res.map((item) => {
                this.tagsCourrier.push({
                  id: item.id,
                  mailId: item.mailId,
                  statusId: item.statusId,
                  description: item.description,
                  creationDate: item.creationDate,
                  color: _.first(this.tags.filter((x) => x.value === item.statusId)).color,
                  textColor: this.getOppositeColor(_.first(this.tags.filter((x) => x.value === item.statusId)).color),
                });
              });
            }
            this.tagsCourrier = [...this.tagsCourrier];
          },
        });
      },
    });
  }

  getCourrierByFile(): Promise<boolean> {
    return new Promise((resolve) => {
      let sourceId: number;
      this.spinner.show();

      // Gestion des tabs concernant les expéditeurs
      // Toujours un Entrant vu qu'on demande plus loin si on veut mettre l'expéditeur en tant que libre (libre = typeEntrantSortant === 'E')
      this.actionTabs = [
        { header: 'existingSenderV', id: 'existing', active: true },
        { header: 'newSender', id: 'new', active: false },
        { header: 'freeSender', id: 'free', active: false },
      ];
      //translation of actionTabs
      this.actionTabs.map((tab) => {
        tab.header = this.translater.translate(tab.header);
      });

      // Gestion de la source
      let temp = [];
      temp = this.sourceListLV.filter((x) => x.typeMail === true);
      if (temp.length > 0) {
        sourceId = _.first(temp).value;
      } else {
        sourceId = null;
      }

      async.waterfall(
        [
          (cb) => {
            this.expediteurIdArray = [];
            this.contactsService.fetchSearchContacts({ email: this.courrierFile.sender.email }, 'iCourrier').subscribe({
              next: (res) => {
                const filteredResponse = res.filter((contact) => !contact.nePlusUtiliser);
                if (filteredResponse.length > 0) {
                  res.map((item) => {
                    this.expediteurIdArray.push(item.id);
                  });
                } else {
                  this.expediteurIdArray = [];
                }
                cb(null);
              },
            });
          },
          (cb) => {
            this.spinner.hide();
            if (this.expediteurIdArray.length === 0) {
              this.confirmationService.confirm({
                message: this.translater.translate('wouldYouLikeAddingSenderToContacts'),
                key: 'confirmContact',
                accept: () => {
                  const ref = this.dialogService.open(ContactNewComponent, {
                    styleClass: 'super-compos-modal-content',
                    dismissableMask: false,
                    width: '70vw',
                    closable: false,
                    baseZIndex: 1000,
                    showHeader: false,
                    data: {
                      caller: 'contact_edition',
                      emailUserFromMailFile: this.courrierFile.sender.email,
                    },
                  });
                  ref.onClose.subscribe({
                    next: (value) => {
                      this.onSelectRecipientOrigin('iCourrier').then(() => {
                        this.form.patchValue({
                          annexeNonScannee: '',
                          annexeNonScanneeNombre: null,
                          annexeDiffusee: '',
                          aCompleter: false,
                          typeEntrantSortant: 'E',
                          confidentiel: this.courrierFile.confidentiel ? this.courrierFile.confidentiel : '',
                          dateEntree: this.courrierFile.dateEntree !== null ? moment(this.courrierFile.dateEntree).toDate() : null,
                          dateDocument: this.courrierFile.dateDocument !== null ? moment(this.courrierFile.dateDocument).toDate() : null,
                          dateEcheance: this.courrierFile.dateEcheance !== null ? moment(this.courrierFile.dateEcheance).toDate() : null,
                          datePostale: this.courrierFile.datePostale !== null ? moment(this.courrierFile.datePostale).toDate() : null,
                          refExpediteur: this.courrierFile.refExpediteur ? this.courrierFile.refExpediteur : '',
                          objet: this.courrierFile.objet ? this.courrierFile.objet : '',
                          serviceProprietaireId: this.courrierFile.serviceProprietaireId ? this.courrierFile.serviceProprietaireId : null,
                          expediteurIdiAdmin: null, // Quand on crée un contact ici on le crée FORCEMENT dans iCourrier => pas possible d'avoir un expediteurIdiAdmin
                          expediteurLibre: null,
                          natureId: this.courrierFile.natureId ? this.courrierFile.natureId : null,
                          sourceId: sourceId,
                          remarques: this.courrierFile.remarques ? this.courrierFile.remarques : null,
                          boiteArchive: this.courrierFile.boiteArchive ? this.courrierFile.boiteArchive : null,
                          classementId: this.courrierFile.classementId ? this.courrierFile.classementId : null,
                          classeurId: this.courrierFile.classeurId ? this.courrierFile.classeurId : null,
                          chemiseId: this.courrierFile.chemiseId ? this.courrierFile.chemiseId : null,
                          CreateMethod: 'FromMail',
                          recipientSource: 'iCourrier',
                        });
                        this.recipientSourceBoolean = true;
                        if (value.id) {
                          this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, value.id).then(() => cb());
                        } else {
                          this.filteredExpediteurs = [];
                          this.expediteurContactNeededToBeAdded = null;
                          cb();
                        }
                      });
                    },
                  });
                },
                reject: () => {
                  this.setTabExpediteurToFree();
                  this.toastr.warning(this.translater.translate('senderNotInContactsAddedAsFree'));
                  this.form.patchValue({
                    annexeNonScannee: '',
                    annexeNonScanneeNombre: null,
                    annexeDiffusee: '',
                    aCompleter: false,
                    typeEntrantSortant: 'E',
                    confidentiel: this.courrierFile.confidentiel ? this.courrierFile.confidentiel : '',
                    dateEntree: this.courrierFile.dateEntree !== null ? moment(this.courrierFile.dateEntree).toDate() : moment(),
                    dateDocument: this.courrierFile.dateDocument !== null ? moment(this.courrierFile.dateDocument).toDate() : null,
                    dateEcheance: this.courrierFile.dateEcheance !== null ? moment(this.courrierFile.dateEcheance).toDate() : null,
                    datePostale: this.courrierFile.datePostale !== null ? moment(this.courrierFile.datePostale).toDate() : null,
                    refExpediteur: this.courrierFile.refExpediteur ? this.courrierFile.refExpediteur : '',
                    objet: this.courrierFile.objet ? this.courrierFile.objet : '',
                    serviceProprietaireId: this.courrierFile.serviceProprietaireId ? this.courrierFile.serviceProprietaireId : null,
                    expediteurId: null,
                    expediteurIdiAdmin: null,
                    expediteurLibre: this.expediteurIdArray.length === 0 ? this.courrierFile.sender.email : '',
                    natureId: this.courrierFile.natureId ? this.courrierFile.natureId : null,
                    sourceId: sourceId,
                    boiteArchive: this.courrierFile.boiteArchive ? this.courrierFile.boiteArchive : null,
                    remarques: this.courrierFile.remarques ? this.courrierFile.remarques : null,
                    classementId: this.courrierFile.classementId ? this.courrierFile.classementId : null,
                    classeurId: this.courrierFile.classeurId ? this.courrierFile.classeurId : null,
                    chemiseId: this.courrierFile.chemiseId ? this.courrierFile.chemiseId : null,
                    CreateMethod: 'FromMail',
                  });
                  cb();
                },
              });
            } else {
              this.onSelectRecipientOrigin('iCourrier').then(() => {
                this.form.patchValue({
                  annexeNonScannee: '',
                  annexeNonScanneeNombre: null,
                  annexeDiffusee: '',
                  aCompleter: false,
                  typeEntrantSortant: 'E',
                  confidentiel: this.courrierFile.confidentiel ? this.courrierFile.confidentiel : '',
                  dateEntree: this.courrierFile.dateEntree !== null ? moment(this.courrierFile.dateEntree).toDate() : null,
                  dateDocument: this.courrierFile.dateDocument !== null ? moment(this.courrierFile.dateDocument).toDate() : null,
                  dateEcheance: this.courrierFile.dateEcheance !== null ? moment(this.courrierFile.dateEcheance).toDate() : null,
                  datePostale: this.courrierFile.datePostale !== null ? moment(this.courrierFile.datePostale).toDate() : null,
                  refExpediteur: this.courrierFile.refExpediteur ? this.courrierFile.refExpediteur : '',
                  objet: this.courrierFile.objet ? this.courrierFile.objet : '',
                  serviceProprietaireId: this.courrierFile.serviceProprietaireId ? this.courrierFile.serviceProprietaireId : null,
                  expediteurIdiAdmin: null,
                  expediteurLibre: null,
                  natureId: this.courrierFile.natureId ? this.courrierFile.natureId : null,
                  sourceId: sourceId,
                  boiteArchive: this.courrierFile.boiteArchive ? this.courrierFile.boiteArchive : null,
                  remarques: this.courrierFile.remarques ? this.courrierFile.remarques : null,
                  classementId: this.courrierFile.classementId ? this.courrierFile.classementId : null,
                  classeurId: this.courrierFile.classeurId ? this.courrierFile.classeurId : null,
                  chemiseId: this.courrierFile.chemiseId ? this.courrierFile.chemiseId : null,
                  CreateMethod: 'FromMail',
                  recipientSource: 'iCourrier',
                });
                this.recipientSourceBoolean = true;
                // Nous sommes au courant qu'il peut y avoir plus d'un expéditeur retrouvé mais il a été convenu que l'expéditeur principal sera toujours le premier trouvé
                if (this.expediteurIdArray[0]) {
                  this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(null, this.expediteurIdArray[0]).then(() => cb());
                } else {
                  this.filteredExpediteurs = [];
                  this.expediteurContactNeededToBeAdded = null;
                  cb(null);
                }
              });
            }
          },
          (cb) => {
            this.MailUniqueId = this.courrierFile?.MailUniqueId ? this.courrierFile.MailUniqueId : null;
            this.form.markAsDirty();
            this.formState.emit({ form: this.form, isFormSubmit: false });
            this.spinner.hide();
            cb();
          },
        ],
        () => {
          resolve(true);
        }
      );
    });
  }

  getLinks(courrierID: number): void {
    this.mailsLinksService.fetchMailLinks(courrierID).subscribe({
      next: (response: MailLinkDto[]) => {
        const mappedResponse: (MailLinkDto & { objet?: string })[] = [...response];
        mappedResponse.map((item) => {
          this.mailsService.fetchMailDetails(+item.courrierId).subscribe({
            next: (res: MailFullInfosDTO) => {
              item.objet = res.refExpediteur || res.objet;
            },
          });
        });
        this.links = mappedResponse;
        // check if its an answer or not
        const linkAnswer = this.links.find((a) => a.courrierId === this.courrier.id && a.typeLiaison === 'Réponse');
        if (linkAnswer) {
          this.linkMailAnswer = linkAnswer;
        }
      },
    });
  }

  getGlobalTypes(): void {
    this.mailsLinksService.getGlobalTypes().subscribe({
      next: (globalTypes) => {
        if (globalTypes.length) {
          globalTypes.map((globalType) => {
            this.typesLV.push({ label: globalType.description, value: globalType.description });
          });
        }
      },
    });
  }

  select(event): void {
    if (event.node?.value) {
      if (this.selectedOption?.value !== event.node.value) {
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
        this.form.patchValue({
          serviceProprietaireId: event.node.value,
        });
        this.serviceProprietaireId = event.node.value;
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOption.label;
      } else {
        this.unselect();
      }
      if (this.typeEntrantSortant === 'S' || this.typeEntrantSortant === 'I') {
        if (this.selectedOption) {
          this.getUsersByServicesID(event.node.value);
        } else {
          this.contacts = [];
        }
      }
    } else {
      this.unselect();
    }
    // For hide option confidentiality in mail creation
    if (this.servicesCreation.length > 0) {
      this.rightSelectedServices = this.servicesCreation.find((x) => x.serviceId === event.node.value);
      if (this.rightSelectedServices?.confidentielParDefaut) {
        setTimeout(() => {
          this.form.patchValue({
            confidentiel: true,
          });
        }, 500);
      } else {
        setTimeout(() => {
          this.form.patchValue({
            confidentiel: false,
          });
        }, 500);
      }
    }
  }

  unselect(): void {
    this.selectedOption = null;
    this.form.patchValue({
      serviceProprietaireId: null,
    });
    this.serviceProprietaireId = null;
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
    this.treeSelect.value = [];
  }

  showRef(event): void {
    let currentSource = [];
    currentSource = this.sourceList.filter((x) => x.id === event);
    if (currentSource.length > 0) {
      this.showRefRecommanded = currentSource[0]['afficherReferenceRecommande'];
    }
  }

  receive_classementUpd(mailUpdated): void {
    this.courrier = mailUpdated;
  }

  typeChange(typeCourrier: string): void {
    //'E' | 'S' | 'I'
    this.typeEntrantSortant = typeCourrier;
    this.form.patchValue({ typeEntrantSortant: typeCourrier, expediteurId: null, expediteurIdiAdmin: null });
    if (typeCourrier === 'S' || typeCourrier === 'I') {
      this.form.patchValue({ recipientSource: null });
      if (this.selectedOption && this.selectedOption.value) {
        this.getUsersByServicesID(this.selectedOption.value);
      } else {
        this.contacts = [];
      }
      const tempIndex = this.actionTabs.map((x) => x.id).indexOf('free');
      if (tempIndex > -1) {
        this.actionTabs.splice(tempIndex, 1);
      }
      const tempIndex2 = this.actionTabs.map((x) => x.id).indexOf('new');
      if (tempIndex2 > -1) {
        this.actionTabs.splice(tempIndex2, 1);
      }
      this.expediteurTabsActive = 'existing';
    } else if (typeCourrier === 'E') {
      this.actionTabs.push({ header: 'newSender', id: 'new', active: false });
      this.actionTabs.push({ header: 'freeSender', id: 'free', active: false });
      this.actionTabs = _.uniq(this.actionTabs, 'id');
      //translation of actionTabs
      this.actionTabs.map((tab) => {
        tab.header = this.translater.translate(tab.header);
      });
      this.filteredExpediteurs = [];
      setTimeout(() => {
        this.onSelectRecipientOrigin('iCourrier');
      });
    }
    this.checkValidatorsExpediteurs();
  }

  changeServiceByType(type): void {
    this.mailType = type;
    this.dataMatrice.type = type;
    this.getMatrice(this.dataMatrice);
  }

  setFocus(): void {
    setTimeout(() => {
      let element = null;
      element = this.renderer.selectRootElement('.ui-tree-filter');
      if (element) {
        element.focus();
      }
    }, 500);
  }

  addTags(tagsToAdd): void {
    if (tagsToAdd && tagsToAdd.length > 0) {
      this.multipleStatutesService.postMailMultipleStatus(this.courrier.id, tagsToAdd.join(',')).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('tagsInfos.labelAddedSuccessfully'));
          this.getTagsByMail(this.courrier);
        },
      });
    } else {
      this.toastr.error(this.translater.translate('tagsInfos.pleaseSelectATag'));
    }
  }
  deleteTags(item): void {
    this.confirmationService.confirm({
      message: this.translater.translate('tagsInfos.wouldYouLikeDeleteTag'),
      accept: () => {
        this.multipleStatutesService.deleteMailMultipleStatutes(this.courrier.id, item.id).subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('tagsInfos.successTagDeleted'));
            this.getTagsByMail(this.courrier);
          },
          error: () => {
            this.toastr.error(this.translater.translate('tagsInfos.errorTagUsedInMailsNoDeletePossible'));
          },
        });
      },
    });
  }

  submitNatureSource(): void {
    const data = this.formNatureSource.value;
    if (data.type === 'typeSource') {
      data.typeSource = true;
    } else {
      data.typeSource = false;
    }
    if (data.type === 'typeNature') {
      data.typeNature = true;
    } else {
      data.typeNature = false;
    }
    if (data.accuseReceptionAutomatique === null) {
      data.accuseReceptionAutomatique = false;
    }
    if (data.afficherReferenceRecommande === null) {
      data.afficherReferenceRecommande = false;
    }
    if (data.envoiRecommande === null) {
      data.envoiRecommande = false;
    }
    if (data.typeMail === null) {
      data.typeMail = false;
    }
    // if ( data.typePv === null){ data.typePv = false;}
    if (data.typeSource === null) {
      data.typeSource = false;
    }
    if (data.typeNature === null) {
      data.typeNature = false;
    }
    if (this.formNatureSource.valid) {
      this.params.postNaturesSources(this.formNatureSource.value).subscribe({
        next: (res: NaturesSources) => {
          this.toastr.success(this.translater.translate('successParameterRegistered'));
          this.showCreate = false;
          this.getNaturesList();
          this.getSourcelist();
          if (res.typeNature) {
            this.form.patchValue({ natureId: res.id });
            this.changeNature(res.id);
          } else if (res.typeSource) {
            this.form.patchValue({ sourceId: res.id });
            this.showRef(res.id);
            this.changeSource(res.id);
          }
        },
      });
    } else {
      this.toastr.warning(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }

  openNatureCreate(type): void {
    this.formNatureSource.reset();
    this.formNatureSource.patchValue({
      type: type,
    });
    this.showCreate = true;
  }

  openObjectCreate(): void {
    this.formObject.patchValue({
      objet: this.form.value.objet,
      serviceId: this.form.value.serviceProprietaireId,
    });
    this.showCreateObject = true;
  }

  getClassements(checkIfArchived?: 'getChemiseChecked' | 'isFromUpdate'): Promise<boolean> {
    return new Promise((resolve) => {
      this.classificationsService.fetchMappedClassificationCodesToPrimeNGDropdowns(true).subscribe({
        next: (res: DropdownClassificationCode[]) => {
          this.codesclassementsLV = res;

          if (this.courrier?.classementId || this.form.value.classementId) {
            this.getClasseur(this.courrier?.classementId ? this.courrier?.classementId : this.form.value.classementId, undefined, checkIfArchived);
          }
          resolve(true);
        },
      });
    });
  }

  onHideClassementMethod(): void {
    if (!this.isDropdownToggled) {
      if (this.form.value.classementId) {
        this.getClasseur(this.form.value.classementId);
      }
    }
  }

  onChangeClassement(): void {
    this.form.patchValue({
      classeurId: null,
      chemiseId: null,
    });
  }

  getClasseur(
    classementID: number,
    getArchived: boolean = null,
    checkIfExistingClasseurIsArchived?: 'getChemiseChecked' | 'isFromUpdate' | 'isAnArchived'
  ): void {
    let classeursArray = [];
    this.classeursLV = [];
    this.allClasseurs = [];
    let svcId = null;
    this.loadingClasseurChemise = true;

    if (classementID) {
      this.courrier ? (this.courrier.classementId = classementID) : null;

      async.waterfall([
        (cb) => {
          if (this.form.value.serviceProprietaireId) {
            svcId = this.form.value.serviceProprietaireId;
            this.classificationsService.fetchFoldersClassificationV2({ SvcIds: svcId, IncludePartages: true }).subscribe({
              next: (res: BinderClassificationDtoV2[]) => {
                this.allDatasForChosenService = [...res];
                cb();
              },
              error: (err: HttpErrorResponse) => {
                console.error(err);
              },
            });
          } else {
            //* if no service then we shouldn't even display the "classeur" => nothing needed in query
            this.allDatasForChosenService = [];
            cb();
          }
        },
        (cb) => {
          if (this.allDatasForChosenService?.length > 0) {
            const foundBinderClassification = this.allDatasForChosenService.find((x) => x.id === classementID);
            if (foundBinderClassification) {
              this.allClasseurs = foundBinderClassification?.classeurs;

              if (getArchived === null || getArchived === false) {
                //* Si on ne veut pas les archivés alors on ne va pas pusher les classements qui sont archivés
                const classeursNotArchived = foundBinderClassification.classeurs.filter((x) => !x.archived);
                classeursNotArchived.forEach((x) => {
                  classeursArray.push(x);
                });
              } else {
                foundBinderClassification.classeurs.forEach((x) => {
                  classeursArray.push(x);
                });
              }

              if (
                checkIfExistingClasseurIsArchived &&
                checkIfExistingClasseurIsArchived.length > 0 &&
                checkIfExistingClasseurIsArchived !== 'getChemiseChecked'
              ) {
                //Si on vient de l'edition d'un classeur ou qu'on a un classeur achivé alors on a qqch dans cette variable
                // alors on va devoir vérifier si le courrier.classeurId est un archivé ou pas pour l'afficher
                if (this.tempMail || this.courrier || this.form.value) {
                  const actualClasseur = this.allClasseurs.find(
                    (x) => x.id === this.courrier?.classeurId || x.id === this.form.value?.classeurId || x.id === this.tempMail?.classeurId
                  );
                  if (actualClasseur?.archived) {
                    this.classeurCheckArchived = true;
                    classeursArray = _.uniq(this.allClasseurs, 'id');
                  }
                }
              }
            }
          }
          cb(null);
        },
        (cb) => {
          setTimeout(() => {
            //on ne patch le classeur que
            //1) s'il existe un courrier/tempMail
            //2) La liste des classeurs contient au moins 1 classeur
            //3) la liste des classeurs contient le classeur du courrier!
            //Sinon si on patch alors qu'on a pas de classeur ou qu'il ne peut pas être choisi, ca va faire des erreurs!
            if (this.courrier && classeursArray.length > 0 && classeursArray.map((x) => x.id).indexOf(this.courrier.classeurId) > -1) {
              this.form.patchValue({
                classeurId: this.courrier.classeurId,
              });
            } else if (this.tempMail && classeursArray.length > 0 && classeursArray.map((x) => x.id).indexOf(this.tempMail.classeurId) > -1) {
              this.form.patchValue({
                classeurId: this.tempMail.classeurId,
              });
            }
            cb();
          }, 1000);
        },
        (cb) => {
          classeursArray.forEach((item) => {
            if (this.classeursLV.map((x) => x.value).indexOf(item.id) === -1) {
              this.classeursLV.push({
                label: item.description,
                value: item.id,
                partage: item.partage,
              });
            }
          });
          cb(null);
        },
        () => {
          if (this.courrier?.classeurId || this.form.value.classeurId || this.tempMail?.classeurId) {
            let idClasseur;
            if (this.courrier?.classeurId) {
              idClasseur = this.courrier.classeurId;
            } else if (this.tempMail?.classeurId) {
              idClasseur = this.tempMail.classeurId;
            } else if (this.form.value.classeurId) {
              idClasseur = this.form.value.classeurId;
            }
            this.getChemises(idClasseur, null, checkIfExistingClasseurIsArchived);
          } else {
            this.spinner.hide();
          }
          this.loadingClasseurChemise = false;
        },
      ]);
    } else {
      this.form.patchValue({
        classementId: null,
        chemiseId: null,
        classeurId: null,
      });
      if (this.courrier) {
        this.courrier.classementId = null;
        this.courrier.chemiseId = null;
        this.courrier.classeurId = null;
      }
      if (this.tempMail) {
        this.tempMail.classementId = null;
        this.tempMail.chemiseId = null;
        this.tempMail.classeurId = null;
      }
      this.chemisesLV = [];
      this.classeursLV = [];
      this.spinner.hide();
      this.loadingClasseurChemise = false;
    }
  }

  getChemises(classeurID: number, getArchived: boolean = null, getChemiseChecked?: 'getChemiseChecked' | 'isFromUpdate' | 'isAnArchived'): void {
    let chemiseArray = [];
    this.chemisesLV = [];
    let allChemises = [];
    this.courrier ? (this.courrier.classeurId = classeurID) : null;

    if (this.allClasseurs?.length > 0) {
      const foundBinder = this.allClasseurs.find((x) => x.id === classeurID);
      if (foundBinder) {
        allChemises = foundBinder.chemises;

        if (getArchived === null || getArchived === false) {
          //* Si on ne veut pas les archivés alors on ne va pas pusher les chemises qui sont archivés
          const chemisesNotArchived = foundBinder.chemises.filter((x) => !x.archived);
          chemisesNotArchived.forEach((x) => {
            chemiseArray.push(x);
          });
        } else {
          //* Si le getArchived est a true, on prend aussi les archivés => aucune condition sur le push
          foundBinder.chemises.forEach((x) => {
            chemiseArray.push(x);
          });
        }
        if (getChemiseChecked === 'getChemiseChecked' || getChemiseChecked === 'isFromUpdate') {
          if (this.courrier || this.form.value || this.tempMail) {
            const actualChemise = allChemises.find(
              (x) => x.id === this.courrier?.chemiseId || x.id === this.form.value?.chemiseId || x.id === this.tempMail?.chemiseId
            );
            if (actualChemise?.archived) {
              this.chemiseCheckArchived = true;
              chemiseArray = allChemises;
            }
          }
        }
      }
    }

    setTimeout(() => {
      //on ne patch la chemise que
      //1) s'il existe un courrier/tempMail
      //2) La liste des chemises contient au moins 1 chemise
      //3) la liste des chemises contient la chemise du courrier!
      //Sinon si on patch alors qu'on a pas de chemise ou qu'elle ne peut pas être choisie, ca va faire des erreurs!
      if (this.courrier && chemiseArray.length > 0 && chemiseArray.map((x) => x.id).indexOf(this.courrier.chemiseId) > -1) {
        this.form.patchValue({
          chemiseId: this.courrier.chemiseId,
        });
      } else if (this.tempMail && chemiseArray.length > 0 && chemiseArray.map((x) => x.id).indexOf(this.tempMail.chemiseId) > -1) {
        this.form.patchValue({
          chemiseId: this.tempMail.chemiseId,
        });
      }
    }, 1000);

    chemiseArray.forEach((item) => {
      if (this.chemisesLV.map((x) => x.value).indexOf(item.id) === -1) {
        this.chemisesLV.push({
          label: item.description,
          value: item.id,
          partage: item.partage,
          service: item.service,
        });
      }
    });
    this.spinner.hide();
  }

  changeNature(value): void {
    this.dataMatrice.natureId = value;
    this.getMatrice(this.dataMatrice);
  }

  changeSource(value): void {
    this.dataMatrice.sourceId = value;
    this.getMatrice(this.dataMatrice);
  }

  duplicate(): void {
    let data = {
      serviceProprietaireId: null,
      dateEntree: null,
      dateDocument: null,
      datePostale: null,
      dateEcheance: null,
      ClassementId: null,
      ChemiseId: null,
      ClasseurId: null,
      DestinatairesUsers: '',
      DestinatairesServiceIds: '',
      Liens: '',
      FileIds: '',
      Files: [],
    };
    const duplicateCheck = JSON.parse(sessionStorage.getItem('duplicateForm'));
    if (duplicateCheck.classements === false) {
      delete this.form.value.ClassementId;
      delete this.form.value.ChemiseId;
      delete this.form.value.ClasseurId;
    }

    if (duplicateCheck.data) {
      data = this.form.value;
      data.DestinatairesUsers = data.DestinatairesUsers ?? '';
      data.DestinatairesServiceIds = data.DestinatairesServiceIds ?? '';
      data.Liens = data.Liens ?? '';
      data.FileIds = data.FileIds ?? '';
      if (data.dateEntree !== null) {
        data.dateEntree = moment(this.form.value.dateEntree).format('YYYY-MM-DD');
      }
      if (data.dateDocument !== null) {
        data.dateDocument = moment(this.form.value.dateDocument).format('YYYY-MM-DD');
      }
      if (data.dateEcheance !== null) {
        data.dateEcheance = moment(this.form.value.dateEcheance).format('YYYY-MM-DD');
      }
      if (data.datePostale !== null) {
        data.datePostale = moment(this.form.value.datePostale).format('YYYY-MM-DD');
      }
    } else {
      if (duplicateCheck.classements) {
        data.ClassementId = this.form.value.ClassementId;
        data.ChemiseId = this.form.value.ChemiseId;
        data.ClasseurId = this.form.value.ClasseurId;
      }
    }

    async.waterfall([
      (cb) => {
        if (duplicateCheck.destinataires) {
          const temp = [];
          const tempService = [];
          this.recipientsService.fetchMailRecipientFullInfos(this.courrier.id).subscribe({
            next: (response) => {
              if (response && response.length > 0) {
                response.map((item) => {
                  if (item.isService === false) {
                    temp.push({
                      statut: item.statut,
                      action: item.action,
                      transmisDate: item.transmisDate,
                      echeance: item.echeance,
                      message: item.message,
                      accuseDeReponse: item.accuseDeReponse,
                      libre: item.libre,
                      serviceProprietaireId: item.serviceProprietaireId,
                      serviceDestinataireId: item.serviceDestinataireId,
                      contacts: item.libre
                        ? []
                        : [
                            {
                              ContactIdiAdmin: item.contactiAdminId,
                              contactId: item.contactId,
                              historiqueDescription: 'Ajout via dupliquer',
                            },
                          ],
                    });
                  } else {
                    tempService.push(item.contactId);
                  }
                });
              }
              data.DestinatairesUsers = JSON.stringify(temp);
              data.DestinatairesServiceIds = JSON.stringify(tempService);
              cb(null);
            },
            error: () => {
              this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingRecipients'));
            },
          });
        } else {
          cb(null);
        }
      },
      (cb) => {
        if (duplicateCheck.links) {
          this.mailsLinksService.fetchMailLinks(this.courrier.id).subscribe({
            next: (response: MailLinkDto[]) => {
              data.Liens = JSON.stringify(response);
              cb(null);
            },
          });
        } else {
          cb(null);
        }
      },
      (cb) => {
        if (duplicateCheck.files) {
          this.filesService.fetchMailFiles(this.courrier.id).subscribe({
            next: (response) => {
              const temp = [];
              if (response && response.length > 0) {
                response.map((item) => {
                  temp.push(item.id);
                });
              }
              data.FileIds = JSON.stringify(temp);
              cb(null);
            },
            error: () => {
              this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingMailsFiles'));
            },
          });
        } else {
          cb(null);
        }
      },
      () => {
        data.Files = this.attachements && this.attachements.length > 0 ? this.attachements : [];
        if (this.form.value.typeEntrantSortant === 'E') {
          if (this.expediteurTabsActive === 'existing') {
            // Si le type de courrier est entrant, ca veut dire qu'on est sur l'autocomplete. l'expediteurId du formulaire est donc un objet!
            this.form.value.expediteurLibre = null;

            if (this.form.value.recipientSource === 'iAdmin') {
              this.form.value.expediteurId = null;
              if (this.form.value.expediteurIdiAdmin?.id) {
                this.form.value.expediteurIdiAdmin = this.form.value.expediteurIdiAdmin.id;
              }
            }

            if (this.form.value.recipientSource === 'iCourrier') {
              this.form.value.expediteurIdiAdmin = null;
              if (this.form.value.expediteurId?.id) {
                this.form.value.expediteurId = this.form.value.expediteurId.id;
              }
            }
          } else {
            this.form.value.expediteurId = null;
          }
        } else {
          this.form.value.expediteurId = null;
          this.form.value.expediteurLibre = null;
        }
        this.mailsService.postDuplicate(this.courrier.id, data).subscribe({
          next: (res) => {
            this.getLocksAccess().then(() => {
              this.courrierIsSaved.emit(this.currentUserLockInfo);
              this.spinner.hide();
              this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('successMailDuplicated'));
              this.router.navigateByUrl('/private/ic/tabs/' + res.id);
            });
          },
        });
      },
    ]);
  }

  getLocksAccess(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.courrier.id) {
        this.mailsLockUnlockService.getLockInfo(this.courrier.id).subscribe({
          next: (res) => {
            this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfos.contactId));
            this.unLock('Write').then(() => {
              resolve(true);
            });
          },
        });
      }
    });
  }

  unLock(mode: string): Promise<boolean> {
    return new Promise((resolve) => {
      const data = {
        courrierIds: [this.courrier.id],
      };
      if (this.courrier.id) {
        this.mailsLockUnlockService.unLock(mode, data).subscribe({
          next: () => {
            if (mode === 'Write') {
              this.toastr.success(this.translater.translate('successMailUnlocked'));
            } else {
              this.toastr.success(this.translater.translate('successMailLocked'));
            }
            resolve(true);
          },
        });
      } else {
        resolve(true);
      }
    });
  }

  showMoreInfoContact(contact): void {
    this.contactsService.fetchContact(contact.value, 'iCourrier').subscribe({
      next: (response) => {
        this.contactInfoComplementary = [];
        this.contactInfoComplementary.push({
          type: response?.typeContactId ? this.contactTypes.find((contactType) => contactType.value === response.typeContactId)?.label : '/',
          societeParente: response.contactParent,
          impression_Adresse: response?.adressePrincipale?.impression_Adresse,
          impression_CodePostal: response?.adressePrincipale?.impression_CodePostal,
          impression_Localite: response?.adressePrincipale?.impression_Localite,
          impression_Pays: response?.adressePrincipale?.impression_Pays,
          gsm: response?.adressePrincipale?.gsm,
          telephone: response?.adressePrincipale?.telephone,
          mail: response?.adressePrincipale?.mail,
        });
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingContacts'));
      },
    });
  }

  openUpdateUser(user): void {
    const ref = this.dialogService.open(ContactEditionComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        hideSwitch: false,
        companyMode: false,
        caller: 'linked',
        contactID: user.value,
      },
    });
    document.addEventListener('DOMContentLoaded', function () {
      const modalContent = document.querySelector('.p-dynamic-dialog');
      if (modalContent) {
        modalContent.setAttribute('draggable', 'true');
      }
    });
    ref.onClose.subscribe({
      next: (contactCreated) => {
        if (contactCreated) {
          this.spinner.show();
          this.fetchContactsOrUsersByTypeOfTypeEntrantSortant(this.f.serviceProprietaireId.value, user.id).then(() => {
            if (this.form.value.typeEntrantSortant === 'S' || this.form.value.typeEntrantSortant === 'I') {
              this.form.value.patchValue({ expediteurIdiAdmin: user.value ? user.value : user.id });
            }
            this.spinner.hide();
          });
        }
      },
    });
  }

  public onUploadClick(): void {
    document.getElementsByClassName('fileUploadCustom')[0].querySelector('input').click();
  }

  filterServiceForObject(value): void {
    this.getModelesObjects();
    if (value) {
      this.objectsmodeles = this.objectsmodeles.filter((x) => x.serviceId === value);
    } else {
      this.getModelesObjects();
    }
  }

  getModelesObjects(): void {
    this.objectsmodeles = [];
    this.objectsTemplatesService.fetchObjectTemplate().subscribe({
      next: (res) => {
        res.map((x) => {
          this.objectsmodeles.push({ label: x.objet, value: x.objet, serviceId: x.serviceId });
        });
        const serviceInForm = this.form.value.serviceProprietaireId;
        if (serviceInForm) {
          this.objectsmodeles = this.objectsmodeles.filter((x) => x.serviceId === serviceInForm);
        }
      },
    });
  }

  submitObject(): void {
    if (this.formObject.valid) {
      this.objectsTemplatesService.postModelesObjets(this.formObject.value).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('successParameterRegistered'));
          this.showCreateObject = false;
          this.form.patchValue({
            objet: this.formObject.value.objet,
          });
          this.getModelesObjects();
        },
      });
    } else {
      this.toastr.warning(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }

  openObjectBibli(): void {
    this.openBibli = true;
    this.getModelesObjects();
  }

  confirmObject(): void {
    this.form.patchValue({
      objet: this.objectModel,
    });
    this.openBibli = false;
  }

  public openAddClassement(): void {
    this.formNewClassement.patchValue({
      description: null,
      actif: true,
      code: null,
    });
    this.showCreateNewClassement = true;
  }

  public submitNewClassement(): void {
    if (this.formNewClassement.valid) {
      this.classificationsService.insertNewClassificationCode(this.formNewClassement.value).subscribe({
        next: (res: { id: number; code: string; description: string; actif: boolean }) => {
          this.toastr.success(this.translater.translate('successClassificationRegistered'));
          this.form.patchValue({
            classementId: res.id,
            classeurId: null,
            chemiseId: null,
          });
          if (this.courrier) {
            this.courrier.classementId = res.id;
            this.courrier.classeurId = null;
            this.courrier.chemiseId = null;
          }

          this.getClassements();

          this.showCreateNewClassement = false;
        },
      });
    } else {
      this.toastr.warning(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }

  public openAddFarde(): void {
    this.headerForModal = this.translater.translate('classification.createBinder');
    this.displayCreateEditBinderComponent = true;
  }

  public onCloseCreateEditBinder(value): void {
    this.displayCreateEditBinderComponent = false;
    /* En premier on va toujours garder la dernière farde créée.
  En effet, si on crée plusieurs fardes mais qu'a la fin on annule, on doit tout de même garder la dernière créée
  */

    //Il se peut qu'on annule directement => la on garde a null (on ne fait rien) et donc on a pas de createdBinder
    // ce qui veut dire que si on avait déjà créé une farde avant alors le lastCreatedBinder sera l'ancienne farde crée
    if (value?.createdBinder) {
      this.lastCreatedBinder = value.createdBinder;
    }
    //si on a un form ca veut dire création multiple
    if (value?.form) {
      setTimeout(() => {
        this.formDatasToSendBackToCreateBinder = value.form;
        this.openAddFarde();
      }, 1000);
    } else {
      // alors on a créé une farde et on prend donc la dernière
      if (this.lastCreatedBinder) {
        this.form.patchValue({
          classeurId: this.lastCreatedBinder.id,
          chemiseId: null,
        });
        if (this.courrier) {
          this.courrier.classeurId = this.lastCreatedBinder.id;
          this.courrier.chemiseId = null;
        }
        // Si la farde créée n'a pas le mm service alors on reload pas, c'est normal sinon on va avoir des fardes pour un service B et on a le service A sur la fiche courrier
        if (this.lastCreatedBinder.serviceProprietaireId === this.form.value.serviceProprietaireId) {
          if (this.lastCreatedBinder.archive) {
            this.getClasseur(this.form.value.classementId, this.classeurCheckArchived, 'isAnArchived');
            this.lastCreatedBinder = null;
          } else {
            this.getClasseur(this.form.value.classementId, this.classeurCheckArchived);
            this.lastCreatedBinder = null;
          }
        }
      }
    }
  }

  public openAddChemise(): void {
    const folderDescription = this.classeursLV.find((classeur) => {
      return classeur.value === +this.form.value.classeurId;
    })?.label;
    this.selectedRowDataForModal = {
      node: {
        data: {
          id: this.form.value.classeurId,
          description: folderDescription,
          classementId: this.form.value.classementId,
          serviceId: this.form.value.serviceProprietaireId,
        },
      },
    };
    this.headerForModal = this.translater.translate('classification.createPlasticLiner');
    this.displayCreateEditPlasticLinerComponent = true;
  }

  onCloseCreateEditPlasticLiner(value): void {
    this.displayCreateEditPlasticLinerComponent = false;
    /* En premier on va toujours garder la dernière chemise créée.
  En effet, si on crée plusieurs chemsies mais qu'a la fin on annule, on doit tout de même garder la dernière créée
  */
    //Il se peut qu'on annule directement => la on garde a null : on ne fait rien
    if (value.createdPlasticLiner) {
      this.lastCreatedPlasticLiner = value.createdPlasticLiner;
    }
    //si on a un form ca veut dire création multiple
    if (value && value.form) {
      setTimeout(() => {
        this.formDatasToSendBackToCreatePlasticLiner = value;
        this.openAddChemise();
      }, 1000);
    } else {
      // alors on a créé une farde et on prend donc la dernière
      if (this.lastCreatedPlasticLiner) {
        this.form.patchValue({
          chemiseId: this.lastCreatedPlasticLiner.id,
        });
        if (this.courrier) {
          this.courrier.chemiseId = this.lastCreatedPlasticLiner.id;
        }
        if (this.lastCreatedPlasticLiner.archive) {
          this.getClasseur(
            this.form.value.classementId ? this.form.value.classementId : this.courrier.classementId,
            this.classeurCheckArchived,
            'getChemiseChecked'
          );
          this.lastCreatedPlasticLiner = null;
        } else {
          this.getClasseur(this.form.value.classementId ? this.form.value.classementId : this.courrier.classementId, this.classeurCheckArchived);
          this.lastCreatedPlasticLiner = null;
        }
      }
    }
  }

  onChangeTabsExpediteurs(event): Promise<boolean> {
    return new Promise((resolve) => {
      this.expediteurTabsActive = event;

      const indexFree = this.actionTabs.map((x) => x.id).indexOf('free');
      const indexNew = this.actionTabs.map((x) => x.id).indexOf('new');
      const indexExisting = this.actionTabs.map((x) => x.id).indexOf('existing');

      //translation of actionTabs

      if (this.expediteurTabsActive === 'free') {
        if (indexFree > -1) {
          this.actionTabs[indexFree].header = this.translater.translate('freeSenderV');
        }
        if (indexNew > -1) {
          this.actionTabs[indexNew].header = this.translater.translate('newSender');
        }
        if (indexExisting > -1) {
          this.actionTabs[indexExisting].header = this.translater.translate('existingSender');
        }
      } else if (event === 'new') {
        this.canSaveContact = false;
        if (indexFree > -1) {
          this.actionTabs[indexFree].header = this.translater.translate('freeSender');
        }
        if (indexNew > -1) {
          this.actionTabs[indexNew].header = this.translater.translate('newSenderV');
        }
        if (indexExisting > -1) {
          this.actionTabs[indexExisting].header = this.translater.translate('existingSender');
        }
      } else if (event === 'existing') {
        if (indexFree > -1) {
          this.actionTabs[indexFree].header = this.translater.translate('freeSender');
        }
        if (indexNew > -1) {
          this.actionTabs[indexNew].header = this.translater.translate('newSender');
        }
        if (indexExisting > -1) {
          this.actionTabs[indexExisting].header = this.translater.translate('existingSenderV');
        }
      }
      this.checkValidatorsExpediteurs();
      resolve(true);
    });
  }

  setTabExpediteurToFree(): void {
    this.actionTabs[0].active = false;
    this.actionTabs[1].active = false;
    this.actionTabs[2].active = true;
    this.expediteurTabsActive = 'free';
    const indexFree = this.actionTabs.map((x) => x.id).indexOf('free');
    const indexNew = this.actionTabs.map((x) => x.id).indexOf('new');
    const indexExisting = this.actionTabs.map((x) => x.id).indexOf('existing');

    if (indexFree > -1) {
      this.actionTabs[indexFree].header = this.translater.translate('freeSenderV');
    }
    if (indexNew > -1) {
      this.actionTabs[indexNew].header = this.translater.translate('newSender');
    }
    if (indexExisting > -1) {
      this.actionTabs[indexExisting].header = this.translater.translate('existingSender');
    }
  }

  public getTranslations(): void {
    this.columnsContactInfoComplementary.map((x) => {
      return (x.header = this.translater.translate(x.header));
    });
  }

  /**
   * * Method to add p-highlight class to current service selected
   */
  onShowTreeSelect(): void {
    if (this.selectedOption) {
      const aTags = document.getElementsByClassName('p-treenode-content');
      let found;
      if (aTags && aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          if (aTags[i].textContent == this.selectedOption.label) {
            found = aTags[i];
            found.classList.add('p-highlight');
            break;
          }
        }
      }
    }
  }

  checkForComplementaryData(nature): void {
    this.loadingComplementaryDatas = true;
    if (nature) {
      this.natureWithComplementaryDatas = this.natureList.find((x) => x.id === nature);
      this.dataToPrepareForForm = { controls: [] };
      if (this.natureWithComplementaryDatas?.natureCustomFields) {
        this.natureWithComplementaryDatas.natureCustomFields.map((field) => {
          if (field.utilisable) {
            const rightNatureCustomDataInMail = this.courrier?.natureCustomDatas?.find((x) => x.natureCustomFieldId === field.id);
            this.dataToPrepareForForm.controls.push({
              customFieldId: field.id,
              id: rightNatureCustomDataInMail?.id ?? null,
              name: field.name,
              description: field.description,
              label: field.name,
              textValue: rightNatureCustomDataInMail?.textValue ?? null,
              dateValue: rightNatureCustomDataInMail?.dateValue ?? null,
              integerValue: rightNatureCustomDataInMail?.integerValue ?? null,
              decimalValue: rightNatureCustomDataInMail?.decimalValue ?? null,
              numberValue: rightNatureCustomDataInMail?.numberValue ?? null,
              listValueItemId: rightNatureCustomDataInMail?.listValueItemId ?? null,
              defaultFormValue: field?.defaultFormValue,
              type: field.customField.type.toLowerCase(),
              natureId: nature,
              validators: null,
              utilisable: field.utilisable,
            });
          }
        });
        this.form.patchValue({
          NatureCustomDatas: this.dataToPrepareForForm.controls,
        });
        setTimeout(() => {
          this.loadingComplementaryDatas = false;
        }, 500);
      }
    } else {
      this.natureWithComplementaryDatas = null;
      this.loadingComplementaryDatas = false;
    }
  }

  receive_complementData(data): void {
    this.form.patchValue({
      NatureCustomDatas: data,
    });
  }

  patchValueFromScan(scan: ScanSentToEditionComponent, duplicatedMailDatasFromiScan): Promise<boolean> {
    return new Promise((resolve) => {
      async.waterfall(
        [
          (callback) => {
            //on regarde d'abord si on a un service dans le QRCode, car celui-ci va prévalloir sur la duplication
            if (scan?.file?.ServiceProprietaireId) {
              setTimeout(() => {
                this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === scan.file.ServiceProprietaireId));
                if (!this.showAllServices) {
                  //Si on n'affiche pas les services enfants alors faut remonter jusqu'au parent 0
                  if (this.selectedOption.parentId > 0) {
                    this.displayWarningChildServiceDetected = true;
                    const parentOriginal = this.getBackToOriginalParent(this.selectedOption);
                    this.selectedOption = parentOriginal;
                    scan.file.ServiceProprietaireId = parentOriginal.value; //En effet, on doit tout faire revenir au parent initial
                    this.scan.file.ServiceProprietaireId = parentOriginal.value; //En effet, on doit tout faire revenir au parent initial

                    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                    if (labelTreeHtml && this.selectedOption) {
                      labelTreeHtml[0].innerHTML = this.selectedOption.label;
                      this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
                    }
                    if (duplicatedMailDatasFromiScan) {
                      duplicatedMailDatasFromiScan.serviceProprietaireId = scan.file.ServiceProprietaireId;
                    }
                    callback();
                  } else {
                    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                    if (labelTreeHtml && this.selectedOption) {
                      labelTreeHtml[0].innerHTML = this.selectedOption.label;
                      this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
                    }
                    if (duplicatedMailDatasFromiScan) {
                      duplicatedMailDatasFromiScan.serviceProprietaireId = scan.file.ServiceProprietaireId;
                    }
                    callback();
                  }
                } else {
                  const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                  if (labelTreeHtml && this.selectedOption) {
                    labelTreeHtml[0].innerHTML = this.selectedOption.label;
                    this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
                  }
                  if (duplicatedMailDatasFromiScan) {
                    duplicatedMailDatasFromiScan.serviceProprietaireId = scan.file.ServiceProprietaireId;
                  }
                  callback();
                }
              });
            } else if (duplicatedMailDatasFromiScan?.serviceProprietaireId) {
              setTimeout(() => {
                this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === duplicatedMailDatasFromiScan.serviceProprietaireId));
                const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
                if (labelTreeHtml && this.selectedOption) {
                  labelTreeHtml[0].innerHTML = this.selectedOption.label;
                  this.patchServiceOnLoopInTreeSelect(this.selectedOption.value);
                }
                callback();
              });
            } else {
              callback();
            }
          },
        ],
        () => {
          this.form.patchValue({
            // ! Attention, un SCAN doit toujours être un entrant MAIS si c'est une duplication alors on garde le type du courrier dupliqué!!
            typeEntrantSortant: duplicatedMailDatasFromiScan ? duplicatedMailDatasFromiScan.typeEntrantSortant : 'E',
            classementId: scan?.file?.CodeClassementId
              ? scan.file.CodeClassementId
              : duplicatedMailDatasFromiScan
                ? duplicatedMailDatasFromiScan.classementId
                : null,
            serviceProprietaireId: scan?.file?.ServiceProprietaireId
              ? scan.file.ServiceProprietaireId
              : duplicatedMailDatasFromiScan
                ? duplicatedMailDatasFromiScan.serviceProprietaireId
                : null,
            sourceId: scan?.file?.SourceId
              ? scan.file.SourceId
              : duplicatedMailDatasFromiScan
                ? duplicatedMailDatasFromiScan.sourceId
                : this.form.value.sourceId,
            CentreNumerisationId: scan?.file?.CentreNumId
              ? scan.file.CentreNumId
              : duplicatedMailDatasFromiScan
                ? duplicatedMailDatasFromiScan.centreNumerisationId
                : this.form.value.centreNumerisationId,
            DestinataireContactId: scan?.file?.DestinataireContactId
              ? scan.file.DestinataireContactId
              : duplicatedMailDatasFromiScan
                ? duplicatedMailDatasFromiScan.expediteurIdiAdmin
                : this.form.value.expediteurId,
          });
          resolve(true);
        }
      );
    });
  }

  getBackToOriginalParent(item): {
    label: string;
    value: number;
    parentId: number;
  } {
    const parent = _.first(this.servicesFusionned.filter((x) => x.value === item.parentId));
    if (parent.parentId > 0) {
      return this.getBackToOriginalParent(parent);
    } else {
      return parent;
    }
  }

  cleanObject(object: MailCreateScanLotFullParams): MailCreateScanLotFullParams {
    const propNames = Object.getOwnPropertyNames(object);
    for (let i = 0; i < propNames.length; i++) {
      const propName = propNames[i];
      if (object[propName] === null || object[propName] === undefined || object[propName] === '') {
        delete object[propName];
      }
    }
    return object;
  }

  getTooltipForClassificationSearch(): string {
    if (!this.form.value.serviceProprietaireId) {
      return this.translater.translate('error.pleaseAddOnlyAService');
    } else {
      return '';
    }
  }

  openModalClassement(): void {
    if (this.form.value.serviceProprietaireId) {
      this.headerForModal = "Classement d'un courrier";
      this.serviceDataForClassificationSearchModal = {
        serviceProprietaireId: this.form.value.serviceProprietaireId,
      };
      this.displayModalClassificationSearch = true;
    } else {
      this.toastr.warning(this.translater.translate('error.pleaseAddOnlyAService'));
    }
  }

  onCloseClassificationSearchModal(value): void {
    this.displayModalClassificationSearch = false;
    if (value && (value.classementId !== null || value.classeurId !== null || value.chemiseId !== null)) {
      //ce que l'on va faire ici c'est
      // 1) setter les données de classement dans les 2 variables globales utilisées partout (pour éviter tout soucis)
      if (this.courrier) {
        this.courrier.classementId = value.classementId;
        this.courrier.classeurId = value.classeurId ? value.classeurId : null;
        this.courrier.chemiseId = value.chemiseId ? value.chemiseId : null;
      }

      if (this.tempMail) {
        this.tempMail.classementId = value.classementId;
        this.tempMail.classeurId = value.classeurId ? value.classeurId : null;
        this.tempMail.chemiseId = value.chemiseId ? value.chemiseId : null;
      }
      //2) patcher le classement directement dans le formulaire
      this.form.patchValue({ classementId: value.classementId });

      //3) si on a pas de variables globales (=> nouveau courrier) , on va prépatcher le formulaire avant de faire l'appel de récupération de données.
      // En effet, si on a pas de variables globale, l'appel this.getClasseur ne va PAS patcher de données :)
      if (!this.courrier && !this.tempMail) {
        this.form.patchValue({ classeurId: value.classeurId ? value.classeurId : null });
        this.form.patchValue({ chemiseId: value.chemiseId ? value.chemiseId : null });
        this.getClasseur(value.classementId, true, 'getChemiseChecked');
      } else {
        //Si on a des variables globales, le fait de les avoir set plus haut va permettre un patch correct des données
        this.getClasseur(value.classementId, true, 'getChemiseChecked');
      }

      //on ne va appeller que this.getClasseur car cette méthode va permettre de
      // récupérer la liste des classeurs liés au classementId et au service
      // patcher les données dans le form s'il y a des vars globales
      // faire un appel pour récupérer les chemises s'il existe un classeurId dans SOIT this.courrier SOIT this.tempMail SOIT le form. Et comme on a patché les variables globales ainsi que le form, s'il y a un classeurId, il sera déjà patché => la méthode s'appellera automatiquement.
      // récupérer les chemises liées au classeurId
      //patcher les données dans le form s'il y a des vars globales
    }
  }

  getRightMail(): Promise<MeRightMailGlobal> {
    return new Promise((resolve) => {
      this.meService.rightMailGlobal().subscribe({
        next: (res: MeRightMailGlobal) => {
          resolve(res);
        },
        error: (error: HttpErrorResponse) => {
          console.error('error:', error);
          this.toastr.error(this.translater.translate('error.errorLoadingRights'));
          this.spinner.hide();
        },
      });
    });
  }

  getBacs(): void {
    async.parallel([
      (callback) => {
        if (this.tempMail.bacId) {
          this.workflows.getBacs().subscribe({
            next: (listOfBacs: BacsDTO[]) => {
              const bacs = listOfBacs.map((x) => new Bacs(x));
              this.tempMail.bacLabelForInfos = bacs.find((bac) => bac.id === this.tempMail.bacId)
                ? bacs.find((bac) => bac.id === this.tempMail.bacId).name
                : null;
              callback();
            },
          });
        } else {
          callback();
        }
      },
      (callback) => {
        if (this.tempMail.workflowId) {
          this.workflows.getWorkflowId(this.tempMail.id, this.tempMail.workflowId).subscribe({
            next: (res: WorkflowInstanceDTO) => {
              this.tempMail.workflowForInfos = new WorkflowInstance(res);
              callback();
            },
          });
        } else {
          callback();
        }
      },
    ]);
  }

  openModalSearchSender(): void {
    this.displaySenderModal = true;
    this.headerForModal = this.translater.translate('editCourrier.searchRecipient');
  }

  onCloseSenderModal(value): void {
    this.displaySenderModal = false;
    if (value && this.typeEntrantSortant !== 'E') {
      this.form.patchValue({
        expediteurId: value.value,
      });
    } else if (value && this.typeEntrantSortant === 'E') {
      if (this.form.value.recipientSource === 'iAdmin') {
        this.form.patchValue({
          expediteurIdiAdmin: value,
        });
      }
      if (this.form.value.recipientSource === 'iCourrier') {
        this.form.patchValue({
          expediteurId: value,
        });
      }
    }
  }

  areContactsLoading = false;

  onSelectRecipientOrigin(origin: 'iCourrier' | 'iAdmin'): Promise<boolean> {
    return new Promise((resolve) => {
      this.form.patchValue({ recipientSource: origin, expediteurId: null, expediteurIdiAdmin: null });
      this.recipientSourceBoolean = origin === 'iCourrier' ? true : false;
      this.checkValidatorsExpediteurs();
      resolve(true);
    });
  }

  /**
   * @description Fetches contacts based on the type of typeEntrantSortant.
   * If typeEntrantSortant is 'S' or 'I', fetches users for the given serviceIdSent.
   * If typeEntrantSortant is 'E', fetches all contact infos based on the contactId sent and of the recipientSource. And patches the form with the sender.
   * @param {number} serviceIdSent - id of the service to fetch users for when type is 'S' or 'I'.
   * @param {number[]} contactId - contactId to fetch infos for when type is 'E'.
   * @returns {Promise<boolean>} - a promise that resolves to true if the contacts/infos were fetched successfully, false otherwise.
   */
  fetchContactsOrUsersByTypeOfTypeEntrantSortant(serviceIdSent?: number, contactId?: number): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.f.typeEntrantSortant.value === 'S' || this.f.typeEntrantSortant.value === 'I') {
        this.spinner.show();
        if (serviceIdSent) {
          this.getUsersByServicesID(serviceIdSent).then(() => {
            resolve(true);
          });
        } else {
          this.contacts = [];
          this.spinner.hide();
          resolve(true);
        }
      } else if (this.f.typeEntrantSortant.value === 'E') {
        this.contactsService.getLowInformationsContactsByApp(this.form.value.recipientSource, { id: [contactId] }).subscribe({
          next: (contacts) => {
            if (contacts.length) {
              // D'abord, on vérifie s'il est inactif. S'il l'est on DOIT le rajouter dans la variable expediteurContactNeededToBeAdded afin que
              // this.formatContacts() le garde dans les données de l'autocomplete
              // En dernier lieu, on le patch dans le formulaire s'il existe dans la liste de suggestions. !! Oui en dernier lieu, si vous inversez, l'expéditeur ne se patchera pas. Je présume que pour se patcher l'autocomplete a besoin de sa liste de suggestions.
              //* JIRA 2943 : ajouter l'expéditeur dans la liste des expéditeurs s'il existe et qu'il est inactif
              if (contacts[0].nePlusUtiliser) {
                this.expediteurContactNeededToBeAdded = contacts[0];
              }
              this.filteredExpediteurs = _.sortBy(this.formatContacts(contacts), 'label');

              if (this.form.value.recipientSource === 'iCourrier') {
                if (this.filteredExpediteurs.map((x) => x.id).indexOf(contacts[0].id) > -1) {
                  this.form.patchValue({ expediteurId: contacts[0] });
                }
              } else if (this.form.value.recipientSource === 'iAdmin') {
                if (this.filteredExpediteurs.map((x) => x.id).indexOf(contacts[0].id) > -1) {
                  this.form.patchValue({ expediteurIdiAdmin: contacts[0] });
                }
              }
              resolve(true);
            } else {
              this.filteredExpediteurs = [];
              this.expediteurContactNeededToBeAdded = null;
              this.form.patchValue({ expediteurId: null, expediteurIdiAdmin: null });
              resolve(false);
            }
          },
        });
      }
    });
  }
  public get formControlNameForExpediteur(): AbstractControl {
    if (this.typeEntrantSortant !== 'E' || (this.typeEntrantSortant === 'E' && this.form.value.recipientSource === 'iAdmin')) {
      return this.form.get('expediteurIdiAdmin');
    }
    return this.form.get('expediteurId');
  }

  searchSenderAutoComplete(event): void {
    if (event.query.length < 3) {
      this.autocomplete.showEmptyMessage = false;
      this.filteredExpediteurs = [];
    } else {
      this.autocomplete.showEmptyMessage = true;
      if (this.subscriptionToAutocompleteSender !== null) {
        this.subscriptionToAutocompleteSender.unsubscribe();
        this.contactsService.stopRequestAutocompleteSender.next();
        this.contactsService.stopRequestAutocompleteSender.complete();
      }

      this.subscriptionToAutocompleteSender = this.contactsService
        .getLowInformationsContactsByAppSubject(this.form.value.recipientSource, {
          search: event.query,
          includeAddressPrincipal: true,
        })
        .subscribe({
          next: (contacts) => {
            this.filteredExpediteurs = _.sortBy(this.formatContacts(contacts), 'label');
          },
        });
    }
  }
  private formatContacts(contacts): Contact[] {
    contacts.map((c) => {
      c.nameTypeContact = this.contactTypes.find((x) => {
        return x.value === c.typeContactID;
      })?.label;
      c.name = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
      c.label = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '') + '(' + c.nameTypeContact + ')';
      c.value = c.id;
      c.adresse = c.adressePrincipale
        ? (c.adressePrincipale?.impression_Adresse ? c.adressePrincipale?.impression_Adresse + ' ' : '') +
          (c.adressePrincipale?.impression_CodePostal ? c.adressePrincipale?.impression_CodePostal + ' ' : '') +
          (c.adressePrincipale?.impression_Localite ? c.adressePrincipale?.impression_Localite + ' ' : '') +
          (c.adressePrincipale?.impression_Pays ? c.adressePrincipale.impression_Pays : '')
        : '';
      c.canVisualizeContact = !c.typeContactID || this.contactTypes.map((type) => type.value).indexOf(c.typeContactID) !== -1;
    });
    // Si on avait un expéditeur de base dans le courrier, on va vérifier s'il existe dans la liste récupérée de la recherche.
    // Comme ça s'il est inactif, on le garde dans la liste filtrée qui sera affichée à l'utilisateur (ICOUR-2943)
    let expediteurContactNeededToBeAddedFoundIdInList: Contact = null;
    if (this.expediteurContactNeededToBeAdded) {
      expediteurContactNeededToBeAddedFoundIdInList = contacts.find((contact) => contact.id === this.expediteurContactNeededToBeAdded.id);
    }
    contacts = contacts.filter((x) => x.nePlusUtiliser !== true && x.canVisualizeContact);
    if (expediteurContactNeededToBeAddedFoundIdInList?.nePlusUtiliser) {
      contacts.push(expediteurContactNeededToBeAddedFoundIdInList);
    }
    return contacts;
  }

  onSelectSender(event): void {
    if (this.form.value.recipientSource === 'iAdmin') {
      this.form.patchValue({ expediteurIdiAdmin: event.value });
    } else if (this.form.value.recipientSource === 'iCourrier') {
      this.form.patchValue({ expediteurId: event.value });
    }
  }

  onChangeToggleButtonUsersContacts(event): void {
    this.onSelectRecipientOrigin(event.checked ? 'iCourrier' : 'iAdmin');
  }
}
